import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import Select from "react-select";
import withReactContent from "sweetalert2-react-content";
import html2pdf from "html2pdf.js";
import leftLogo from '../../assets/img/logo/new-logo.png';
import rightLogo from '../../assets/img/logo/punjab-logo.png';
import PGTDutyStationForm from "./PostgraduateRoster";
import ConsultantWardRoster from "./ConsultantWardRoster";
import ConsultantEchoRoster from "./ConsultantEchoRoster";


import { useNavigate } from "react-router-dom"; // ✅ Required for navigation
import {
  FaUserMd,
  FaPhone,
  FaCalendarAlt,
  FaUserTag,
  FaClipboardList,
  FaClock,
  FaUserCheck,
  FaFireExtinguisher,
  FaUserTie,
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationTriangle
} from "react-icons/fa";
import RICLongShortRoster from "./RICLongShortRoster";
import RosterForm from "./RosterForm";
import WardBoyAyaITC from "./WardBoyAyaITC";
import WardBoyAyaRoster from "./WardBoyAyaRoster";
import RICLastSaturdayRoster from "./RICLastSaturdayRoster";
import HDU2wardroster from "./HDU2wardroster";
import WardboyAya from "./WardboyAya";
import GeneralWardCCU1PostCath from "./GeneralWardCCU1PostCath";
import GynaeWardAya from "./GynaeWardAya";
import WardboyAyaGeneralWard from "./WardboyAyaGeneralWard";
import BiogasesDepartmentRoster from "./BiogasesDepartmentRoster";
import ITC3wardBoyAya from "./ITC3wardBoyAya";
import PathologyDepartmentRoster from "./PathologyDepartmentRoster";
import DriverRoster from "./DriverRoster";
import CardiacSurgeryWardRoster from "./CardiacSurgeryWardRoster";
import MaleDoctorHostelRoster from "./MaleDoctorHostelRoster";
import PhysiotherapyRoster from "./PhysiotherapyRoster";
import RadiologyDepartment from "./RadiologyDepartment";
import FilterTesting from "./FilterTesting";
import TechincalDept from "./TechnicalDept";
import BiomedicalDepartment from "./BiomedicalDepartment";
import EttDepartment from "./EttDepartment";
import HvacDepartment from "./HvacDepartment";
import EcgDepartment from "./EcgDepartment";
import CssdDepartment from "./CssdDepartment";
import SurgicalDepartment from "./SurgicalDepartment";
import DoctorsAttendance from "./DoctorsAttendance";

  // ✅ Define all possible rosters in a constant OUTSIDE of state name
  const allRosters = [
    { value: "Doctor", label: "Part 1 Evening / Night Roaster" },
    { value: "FireFighter", label: "Fire Fighter Team Roaster" },
    { value: "VVIP", label: "VVIP Movement Roaster" },
    { value: "csw", label: "Cardiac Surgery Ward Roaster" },
    { value: "gw", label: "General Ward Roaster" },
    { value: "cathlab", label: "Post Cath Lab Roaster" },
    { value: "otroaster", label: "OT Roaster" },
    { value: "er", label: "ER Roaster" },
    { value: "cwo", label: "Consultant Roster OPD" },
    { value: "pgt", label: "Postgraduate Trainees Duty Station Roster" },
    { value: "cwr", label: "Consultant Ward Roster" },
    { value: "cer", label: "Consultant Echo Roster" },
    { value: "lnsr", label: "Long & Short Roster" },
    { value: "AMS", label: "AMS Roaster", disabled: true },
    { value: "RICCathLab", label: "Cath Lab Roster" },
    { value: "ITCWardboyAya", label: "Doctors Roster Random" },
    { value: "itcWardaya", label: "ITC Ward Boys / Aya Roster" },
    { value: "cpcroster", label: "CPC Roster" },
    { value: "dwhdu2", label: "Department / Ward HDU 2 Roster" },
    { value: "wardboyaya", label: "Department / Ward Cardiac Medicine Ward (Ward Boy / Aya) Roster" },
    { value: "gwccupc", label: "General Ward CCU 1 AND Post Cath (Ward Boy / Aya) Roster" },
    { value: "gwar", label: "Gynae Ward Aya's Roster" },
    { value: "wbagwr", label: "Ward Boy / Aya General Ward Roster" },
    { value: "bgdr", label: "Biogases Department Roster" },
    { value: "wbaitc3", label: "Ward Boy / Aya ITC 3 / Private Surgical" },
    { value: "pdr", label: "Pathology Department Roster" },
    { value: "driverRoster", label: "Driver Roster" },
    { value: "CSWRoster", label: "Cardiac Surgery Ward Roster" },
    { value: "mdhr", label: "Male Doctor Hostel Roster" },
    { value: "physioRoster", label: "Physiotherapy Roster" },
    { value: "radiologyRoster", label: "Radiology Department Roster" },
    { value: "filterTesting", label: "Custom Data - Filter" },
    { value: "tdr", label: "Technical Departmet Roster" },
    { value: "bmdr", label: "Biomedical Departmet Roster" },
    { value: "ettdr", label: "ETT Departmet Roster" },
    { value: "hvacdr", label: "HVAC Departmet Roster" },
    { value: "ecgdr", label: "ECG Departmet Roster" },
    { value: "cssdr", label: "CSSD Departmet Roster" },
    { value: "sdr", label: "Surgical Departmet Roster" },
    { value: "private-attendance", label: "Doctors Attendance" }
  ];


const MySwal = withReactContent(Swal);

const showToast = (type, message) => {
  MySwal.fire({
    title: message,
    icon: type,
    toast: false, // full-screen modal style
    position: "center",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    customClass: {
      popup: 'rounded-4 shadow-lg px-5 py-4',
      title: 'fs-5 fw-semibold',
    },
    background: "#fff",
    didOpen: (popup) => {
      popup.addEventListener("mouseenter", Swal.stopTimer);
      popup.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
};

const DutyForm = () => {
  const navigate = useNavigate(); // ✅ Define navigate
  const [selection, setSelection] = useState(""); // Doctor or Fire Fighter

  // Duty Form State
  const [form, setForm] = useState({
    name: "",
    contact: "",
    role: "Doctor",
    section: "",
    shift: "",
    onCall: "",
    date: "",
  });
  const [suggestions, setSuggestions] = useState([]);
  const [isDateEditable, setIsDateEditable] = useState(false);
  const [amsSuggestions, setAmsSuggestions] = useState([]);
 const [rosters, setRosters] = useState([]);


    const [amsForm, setAmsForm] = useState({
      date: new Date().toISOString().split("T")[0],
      days: "",
      evening: ""
    });


const [cathForm, setCathForm] = useState({
  date: new Date().toISOString().split("T")[0],
  days: "",
  lab: "LAB A",
  labData: "",
  listUncharges: "",
  adminInCharge: "",
  newLab: "",
  labOptions: ["LAB A", "LAB B", "LAB C", "LAB D"],
});


// States
const [vvipForm, setVvipForm] = useState({
  date: "",
  day: "",
  shift: "Morning", // start from Morning
  doctor: "",
});

const [vvipSuggestions, setVvipSuggestions] = useState([]);
const [highlightedIndex, setHighlightedIndex] = useState(-1);


const [cswForm, setCswForm] = useState({
  date: "",
  day: "",
  shift: "Morning",
  role: "",
  name: "",
});

const [cswSuggestions, setCswSuggestions] = useState([]);
const [highlightedCswIndex, setHighlightedCswIndex] = useState(-1);

const handleCswNameChange = (e) => {
  const value = e.target.value;
  setCswForm((prev) => ({ ...prev, name: value }));
  setHighlightedCswIndex(-1);

  const lastWord = value.split(/[\s,]+/).pop().trim();

  if (lastWord.length >= 1) {
    axios
      .get(`https://ricgop.online/backend/getCswNames.php?name=${encodeURIComponent(lastWord)}`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setCswSuggestions(res.data);
        } else {
          setCswSuggestions([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching CSW suggestions:", err);
        setCswSuggestions([]);
      });
  } else {
    setCswSuggestions([]);
  }
};


const handleCswKeyDown = (e) => {
  if (cswSuggestions.length === 0) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedCswIndex((prev) => (prev + 1) % cswSuggestions.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedCswIndex((prev) =>
      prev === 0 || prev === -1 ? cswSuggestions.length - 1 : prev - 1
    );
  } else if (e.key === "Enter") {
    if (highlightedCswIndex >= 0) {
      e.preventDefault();
      handleCswSuggestionInsert(cswSuggestions[highlightedCswIndex]);
    }
  } else if (e.key === "Escape") {
    setCswSuggestions([]);
    setHighlightedCswIndex(-1);
  }
};

const handleCswSuggestionInsert = (name) => {
  const textarea = document.getElementById("cswNameTextarea");
  const cursor = textarea.selectionStart;
  const currentText = cswForm.name;

  const match = currentText.slice(0, cursor).match(/[\w\s]*$/);
  const insertStart = match ? cursor - match[0].length : cursor;

  const textBefore = currentText.slice(0, insertStart);
  const textAfter = currentText.slice(cursor);

  const separator =
    textBefore.trim().endsWith(",") || textBefore.trim() === "" ? "" : ", ";
  const newText = textBefore + separator + name + textAfter;

  setCswForm((prev) => ({ ...prev, name: newText.trimStart() }));
  setCswSuggestions([]);
  setHighlightedCswIndex(-1);
  setTimeout(() => textarea.focus(), 0);
};


const [gwForm, setGwForm] = useState({
  date: "",
  day: "",
  shift: "Morning",
  role: "",
  name: "",
});

const [gwSuggestions, setGwSuggestions] = useState([]);
const [highlightedGwIndex, setHighlightedGwIndex] = useState(-1);

const handleGwNameChange = (e) => {
  const value = e.target.value;
  setGwForm((prev) => ({ ...prev, name: value }));
  setHighlightedGwIndex(-1);

  const lastWord = value.split(/[\s,]+/).pop().trim();

  if (lastWord.length >= 1) {
    axios
      .get(`https://ricgop.online/backend/getGwNames.php?name=${encodeURIComponent(lastWord)}`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setGwSuggestions(res.data);
        } else {
          setGwSuggestions([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching GW suggestions:", err);
        setGwSuggestions([]);
      });
  } else {
    setGwSuggestions([]);
  }
};

const handleGwKeyDown = (e) => {
  if (gwSuggestions.length === 0) return;
  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedGwIndex((prev) => (prev + 1) % gwSuggestions.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedGwIndex((prev) =>
      prev === 0 || prev === -1 ? gwSuggestions.length - 1 : prev - 1
    );
  } else if (e.key === "Enter") {
    if (highlightedGwIndex >= 0) {
      e.preventDefault();
      handleGwSuggestionInsert(gwSuggestions[highlightedGwIndex]);
    }
  } else if (e.key === "Escape") {
    setGwSuggestions([]);
    setHighlightedGwIndex(-1);
  }
};

const handleGwSuggestionInsert = (name) => {
  const textarea = document.getElementById("gwNameTextarea");
  const cursor = textarea.selectionStart;
  const currentText = gwForm.name;

  const match = currentText.slice(0, cursor).match(/[\w\s]*$/);
  const insertStart = match ? cursor - match[0].length : cursor;

  const textBefore = currentText.slice(0, insertStart);
  const textAfter = currentText.slice(cursor);

  const separator = textBefore.trim().endsWith(",") || textBefore.trim() === "" ? "" : ", ";
  const newText = textBefore + separator + name + textAfter;

  setGwForm((prev) => ({ ...prev, name: newText.trimStart() }));
  setGwSuggestions([]);
  setHighlightedGwIndex(-1);
  setTimeout(() => textarea.focus(), 0);
};

// Constants
const dayIcons = {
  monday: "🌞",
  tuesday: "💼",
  wednesday: "🧠",
  thursday: "📚",
  friday: "🩺",
  saturday: "💼",
};

const currentMonthYear = new Date().toLocaleString("default", {
  month: "long",
  year: "numeric",
});

// State
const [wsForm, setWsForm] = useState({
  month: currentMonthYear,
  workstation: "",
  monday: "",
  tuesday: "",
  wednesday: "",
  thursday: "",
  friday: "",
  saturday: "",
});

const [wsSuggestions, setWsSuggestions] = useState([]);
const [highlightedWsIndex, setHighlightedWsIndex] = useState(-1);
const [focusedDay, setFocusedDay] = useState(null);
const [wsPreview, setWsPreview] = useState(null);

// Extra Feature States
const [searchMonth, setSearchMonth] = useState("");
const [searchResults, setSearchResults] = useState([]);
const [isSendingEmail, setIsSendingEmail] = useState(false);
const [selectedSearchMonth, setSelectedSearchMonth] = useState(currentMonthYear);
const [rosterByMonth, setRosterByMonth] = useState([]);

// Input Handlers
const handleWsChange = (e) => {
  const { name, value } = e.target;

  let formattedValue = value
    .replace(/,\s*/g, ", ")
    .replace(/,{2,}/g, ", ");

  setWsForm((prev) => ({ ...prev, [name]: formattedValue }));

  if (["monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].includes(name)) {
    setFocusedDay(name);
    const lastWord = formattedValue.split(/[\s,]+/).pop().trim();

    if (lastWord.length >= 1) {
      axios
        .get(`https://ricgop.online/backend/getWsNames.php?name=${encodeURIComponent(lastWord)}`)
        .then((res) => {
          if (Array.isArray(res.data)) {
            setWsSuggestions(res.data);
          } else {
            setWsSuggestions([]);
          }
        })
        .catch((err) => {
          console.error("Error fetching suggestions:", err);
          setWsSuggestions([]);
        });
    } else {
      setWsSuggestions([]);
    }
  }
};

const handleWsKeyDown = (e) => {
  if (wsSuggestions.length === 0) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedWsIndex((prev) => (prev + 1) % wsSuggestions.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedWsIndex((prev) =>
      prev === 0 || prev === -1 ? wsSuggestions.length - 1 : prev - 1
    );
  } else if (e.key === "Enter") {
    if (highlightedWsIndex >= 0) {
      e.preventDefault();
      handleWsSuggestionInsert(wsSuggestions[highlightedWsIndex]);
    }
  } else if (e.key === "Escape") {
    setWsSuggestions([]);
    setHighlightedWsIndex(-1);
  }
};

const handleWsSuggestionInsert = (name) => {
  const textarea = document.getElementById(`ws-${focusedDay}`);
  const cursor = textarea.selectionStart;
  const currentText = wsForm[focusedDay];

  const match = currentText.slice(0, cursor).match(/[\w\s]*$/);
  const insertStart = match ? cursor - match[0].length : cursor;

  const textBefore = currentText.slice(0, insertStart);
  const textAfter = currentText.slice(cursor);

  const separator = textBefore.trim().endsWith(",") || textBefore.trim() === "" ? "" : ", ";
  const newText = textBefore + separator + name + textAfter;

  setWsForm((prev) => ({ ...prev, [focusedDay]: newText.trimStart() }));
  setWsSuggestions([]);
  setHighlightedWsIndex(-1);
  setTimeout(() => textarea.focus(), 0);
};

const submitWsForm = async (e) => {
  e.preventDefault();

  const result = await Swal.fire({
    icon: "info",
    title: "🔍 Preview Roster Submission",
    html: `
      <div style="text-align: left">
        <p><strong>🗕️ Month:</strong> ${wsForm.month}</p>
        <p><strong>🏥 Workstation:</strong> ${wsForm.workstation}</p>
        <p><strong>🌞 Monday:</strong> ${wsForm.monday || "<em>No entry</em>"}</p>
        <p><strong>💼 Tuesday:</strong> ${wsForm.tuesday || "<em>No entry</em>"}</p>
        <p><strong>🧠 Wednesday:</strong> ${wsForm.wednesday || "<em>No entry</em>"}</p>
        <p><strong>📚 Thursday:</strong> ${wsForm.thursday || "<em>No entry</em>"}</p>
        <p><strong>🩺 Friday:</strong> ${wsForm.friday || "<em>No entry</em>"}</p>
        <p><strong>💼 Saturday:</strong> ${wsForm.saturday || "<em>No entry</em>"}</p>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "✅ Confirm & Submit",
    cancelButtonText: "❌ Cancel",
    width: 600,
  });

  if (!result.isConfirmed) return;

  try {
    const res = await axios.post("https://ricgop.online/backend/insertStationRoster.php", wsForm);
    if (res.data.success) {
      await Swal.fire({
        icon: "success",
        title: "✅ Roster Saved Successfully!",
        text: "Your Monthly schedule has been saved.",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        position: "center",
        background: "#f0f9ff",
        customClass: {
          popup: "rounded-4 shadow-lg",
          title: "text-success",
        },
      });

      setWsForm((prev) => ({
        month: prev.month,
        workstation: "",
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
      }));
    } else {
      Swal.fire({
        icon: "error",
        title: "❌ Submission Failed",
        text: res.data.error || "Unknown error occurred.",
      });
    }
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: "error",
      title: "⚠️ Network Error",
      text: "Something went wrong. Please try again later.",
    });
  }
};

// NEW FEATURES:




const handleEmailRoster = async () => {
  try {
    if (!selectedSearchMonth) {
      Swal.fire({
        icon: "warning",
        title: "Month Required",
        text: "Please select a month before emailing.",
      });
      return;
    }

    // Show loading popup with progress and timer
    Swal.fire({
      title: "📨 Preparing Email",
      html: 'Generating roster PDFs... <b id="progress">0</b>%',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => Swal.showLoading(),
    });

    const res = await axios.get(
      `https://ricgop.online/backend/getRosterByMonth.php?month=${encodeURIComponent(selectedSearchMonth)}`
    );

    if (!res.data?.success || !Array.isArray(res.data.data) || res.data.data.length === 0) {
      Swal.close();
      Swal.fire({
        icon: "info",
        title: "No Roster Found",
        text: `No roster data found for "${selectedSearchMonth}".`,
      });
      return;
    }

    const rosterData = res.data.data;

    const leftLogoUrl = "/assets/img/logo/new-logo.png";  // ✅ Make sure these paths are correct
    const rightLogoUrl = "/assets/img/logo/punjab-logo.png";
    const hospitalName = "Rawalpindi Institute of Cardiology";

    // Generate English PDF Blob
    const englishBlob = await generatePDFBlob({
      rosterData,
      language: "en",
      hospitalName,
      selectedSearchMonth,
      leftLogoUrl,
      rightLogoUrl,
    });

    // Generate Urdu PDF Blob
    const urduBlob = await generatePDFBlob({
      rosterData,
      language: "ur",
      hospitalName,
      selectedSearchMonth,
      leftLogoUrl,
      rightLogoUrl,
    });

    // Update progress to 100%
    const progressEl = document.getElementById("progress");
    if (progressEl) progressEl.textContent = `100`;

    // Combine files in FormData
    const formData = new FormData();
    formData.append("englishPDF", new File([englishBlob], `Roster_${selectedSearchMonth}_EN.pdf`, { type: "application/pdf" }));
    formData.append("urduPDF", new File([urduBlob], `Roster_${selectedSearchMonth}_UR.pdf`, { type: "application/pdf" }));
    formData.append("month", selectedSearchMonth); // Optional: pass month info

    // Send to backend
    await axios.post("https://ricgop.online/backend/emailRoster.php", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        const b = document.getElementById("progress");
        if (b) b.textContent = `${percent}`;
      },
    });

    Swal.close();
    Swal.fire({
      icon: "success",
      title: "📧 Roster Emailed!",
      text: "Doctors will receive this schedule shortly.",
      timer: 2500,
      timerProgressBar: true,
      position: "center",
      showConfirmButton: false,
      background: "#f0fdf4",
      customClass: {
        popup: "rounded-4 shadow",
        title: "text-success",
      },
    });
  } catch (error) {
    console.error("Email Error:", error);
    Swal.close();
    Swal.fire({
      icon: "error",
      title: "❌ Email Failed",
      text: "Could not send email. Please try again.",
    });
  }
};



    // Define HTML generators for English and Urdu PDF
const generateEnglishRosterHTML = (rosterData, selectedMonth) => {
  return `
    <div style="font-family: 'Segoe UI', Arial, sans-serif; padding: 20px; color: #2c3e50;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
        <img src="${leftLogo}" alt="Left Logo" style="height: 60px;" />
        <div style="text-align: center; flex: 1;">
          <h2 style="margin: 0; font-weight: 700;">Rawalpindi Institute of Cardiology</h2>
          <p style="margin: 2px 0; font-size: 13px; color: #555;">Rawal Road, Rawalpindi</p>
          <h4 style="margin: 6px 0; color: #444;">Consultant Duty Roster – ${selectedMonth}</h4>
        </div>
        <img src="${rightLogo}" alt="Right Logo" style="height: 60px;" />
      </div>
      <table style="width: 100%; border-collapse: collapse; font-size: 13px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); border-radius: 10px; overflow: hidden;">
        <thead>
          <tr style="background: linear-gradient(to right, #0052D4, #4364F7); color: #fff;">
            <th style="padding: 12px;">Workstation</th>
            <th style="padding: 12px;">Monday</th>
            <th style="padding: 12px;">Tuesday</th>
            <th style="padding: 12px;">Wednesday</th>
            <th style="padding: 12px;">Thursday</th>
            <th style="padding: 12px;">Friday</th>
            <th style="padding: 12px;">Saturday</th>
          </tr>
        </thead>
        <tbody>
          ${rosterData.map((entry, index) => `
            <tr style="background-color: ${index % 2 === 0 ? '#f4f6fb' : '#ffffff'};">
              <td style="padding: 10px;">${entry.workstation}</td>
              <td style="padding: 10px;">${entry.monday}</td>
              <td style="padding: 10px;">${entry.tuesday}</td>
              <td style="padding: 10px;">${entry.wednesday}</td>
              <td style="padding: 10px;">${entry.thursday}</td>
              <td style="padding: 10px;">${entry.friday}</td>
              <td style="padding: 10px;">${entry.saturday}</td>
            </tr>`).join('')}
        </tbody>
      </table>

      <div style="display: flex; justify-content: space-between; margin-top: 60px; font-size: 13px;">
        <div style="text-align: left;">
          <div>____________________________</div>
          <strong>Dr. Hamza Azhar Ghauri</strong><br />
          Assistant Professor of Cardiology / Roster Incharge<br />
          Rawalpindi Institute of Cardiology
        </div>
        <div style="text-align: right;">
          <div>____________________________</div>
          <strong>Dr. Asim Javed</strong><br />
          Associate Professor of Cardiology / HOD<br />
          Rawalpindi Institute of Cardiology
        </div>
      </div>

      <p style="text-align: center; margin-top: 40px; font-size: 10px; color: #888;">
        © ${new Date().getFullYear()} Rawalpindi Institute of Cardiology. All rights reserved.
      </p>
    </div>`;
};


const generateUrduRosterHTML = (rosterData, selectedMonth) => {
  return `
    <div style="font-family: 'Jameel Noori Nastaleeq', serif; direction: rtl; padding: 20px; text-align: right;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
        <img src="${leftLogo}" alt="لوگو" style="height: 60px;" />
        <div style="text-align: center; flex: 1;">
          <h2 style="margin: 0;">راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی</h2>
          <p style="margin: 4px 0;">راول روڈ، راولپنڈی</p>
          <h4 style="margin: 4px 0;">ڈاکٹروں کی ڈیوٹی روسٹر – ${selectedMonth}</h4>
        </div>
        <img src="${rightLogo}" alt="لوگو" style="height: 60px;" />
      </div>

      <table style="width: 100%; border-collapse: collapse; font-size: 15px;">
        <thead>
          <tr style="background-color: #004085; color: white;">
            <th style="padding: 10px;">ورک سٹیشن</th>
            <th style="padding: 10px;">پیر</th>
            <th style="padding: 10px;">منگل</th>
            <th style="padding: 10px;">بدھ</th>
            <th style="padding: 10px;">جمعرات</th>
            <th style="padding: 10px;">جمعہ</th>
            <th style="padding: 10px;">ہفتہ</th>
          </tr>
        </thead>
        <tbody>
          ${rosterData.map((entry, index) => `
            <tr style="background-color: ${index % 2 === 0 ? '#f4f6fb' : '#ffffff'};">
              <td style="padding: 8px;">${entry.workstation}</td>
              <td style="padding: 8px;">${entry.monday}</td>
              <td style="padding: 8px;">${entry.tuesday}</td>
              <td style="padding: 8px;">${entry.wednesday}</td>
              <td style="padding: 8px;">${entry.thursday}</td>
              <td style="padding: 8px;">${entry.friday}</td>
              <td style="padding: 8px;">${entry.saturday}</td>
            </tr>`).join('')}
        </tbody>
      </table>

      <div style="display: flex; justify-content: space-between; margin-top: 40px; font-size: 13px;">
        <div>
          <div>____________________________</div>
          <strong>ڈاکٹر حمزہ اظہر غوری</strong><br />
          اسسٹنٹ پروفیسر کارڈیالوجی / انچارج روسٹر<br />
          راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی
        </div>
        <div>
          <div>____________________________</div>
          <strong>ڈاکٹر عاصم جاوید</strong><br />
          ایسوسی ایٹ پروفیسر کارڈیالوجی / سربراہ شعبہ<br />
          راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی
        </div>
      </div>

      <p style="margin-top: 30px; text-align: center; font-size: 12px; color: #888;">
        © ${new Date().getFullYear()} راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی۔ جملہ حقوق محفوظ ہیں۔
      </p>
    </div>`;
};

const generatePDFBlob = async ({
  rosterData,
  language,
  hospitalName,
  selectedSearchMonth,
  leftLogoUrl,
  rightLogoUrl,
}) => {
  const isUrdu = language === "ur";
  const html = isUrdu
    ? generateUrduRosterHTML(rosterData, selectedSearchMonth)
    : generateEnglishRosterHTML(rosterData, selectedSearchMonth);

  const div = document.createElement("div");
  div.innerHTML = html;

  if (isUrdu) {
    const urduFontLink = document.createElement("link");
    urduFontLink.rel = "stylesheet";
    urduFontLink.href = "https://cdn.jsdelivr.net/gh/noornabi2468/fonts@latest/Jameel%20Noori%20Nastaleeq/font.css";
    document.head.appendChild(urduFontLink);
  }

  const opt = {
    margin: 0.5,
    filename: `Roster_${selectedSearchMonth}_${language.toUpperCase()}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
  };

  return await html2pdf().from(div).set(opt).output("blob");
};

// Make sure your logos are correctly placed in public folder or update URLs accordingly
// Now use generatePDFBlob inside handleEmailRoster (which is already working correctly)

// ✅ Export the function if needed elsewhere



const fetchRosterByMonth = async (month) => {
  try {
    const res = await axios.get(
      `https://ricgop.online/backend/getRosterByMonth.php?month=${encodeURIComponent(month)}`
    );

    if (res.status === 200 && res.data?.success && Array.isArray(res.data.data)) {
      const allWorkstations = res.data.data;

      setRosterByMonth(allWorkstations); // ✅ For PDF use

      // Optionally prefill the form with first row
      if (allWorkstations.length > 0) {
        const first = allWorkstations[0];
        setWsForm({
          month: first.month || month,
          workstation: first.workstation || "",
          monday: first.monday || "",
          tuesday: first.tuesday || "",
          wednesday: first.wednesday || "",
          thursday: first.thursday || "",
          friday: first.friday || "",
          saturday: first.saturday || "",
        });
      }
    } else {
      setRosterByMonth([]); // Clear table for PDF
      setWsForm({
        month,
        workstation: "",
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
      });

      Swal.fire({
        icon: "info",
        title: "No Roster Found",
        text: `No duty roster found for "${month}".`,
        confirmButtonText: "OK",
        customClass: {
          popup: "rounded-4",
        },
      });
    }
  } catch (err) {
    console.error("Roster fetch error:", err);

    setRosterByMonth([]);
    setWsForm({
      month,
      workstation: "",
      monday: "",
      tuesday: "",
      wednesday: "",
      thursday: "",
      friday: "",
      saturday: "",
    });

    Swal.fire({
      icon: "error",
      title: "Fetch Failed",
      text: `Could not retrieve the roster for "${month}". Please try again later.`,
      confirmButtonText: "OK",
      customClass: {
        popup: "rounded-4",
      },
    });
  }
};

const translate = async (text) => {
  if (!text) return "";
  try {
    const res = await fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ur&dt=t&q=${encodeURIComponent(text)}`
    );
    const json = await res.json();
    return json?.[0]?.map((part) => part[0]).join(" ") || text;
  } catch {
    return text;
  }
};

const loadImageBase64 = (url) =>
  new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = () => resolve("");
    img.src = url;
  });

const handleDownloadRoster = async () => {
  try {
    if (!selectedSearchMonth) {
      Swal.fire({
        icon: "warning",
        title: "Month Required",
        text: "Please select a month before downloading.",
      });
      return;
    }

    const res = await axios.get(
      `https://ricgop.online/backend/getRosterByMonth.php?month=${encodeURIComponent(
        selectedSearchMonth
      )}`
    );

    if (
      !res.data?.success ||
      !Array.isArray(res.data.data) ||
      res.data.data.length === 0
    ) {
      Swal.fire({
        icon: "info",
        title: "No Roster Found",
        text: `No roster data found for "${selectedSearchMonth}".`,
      });
      return;
    }

    const rosterData = res.data.data;
    const leftLogoUrl = await loadImageBase64("../../assets/img/logo/new-logo.png");
    const rightLogoUrl = await loadImageBase64("../../assets/img/logo/punjab-logo.png");

    const jameelFontLink = document.createElement("link");
    jameelFontLink.rel = "stylesheet";
    jameelFontLink.href =
      "https://fonts.googleapis.com/earlyaccess/notonastaliqurdu.css";
    document.head.appendChild(jameelFontLink);

    const html2pdf = (await import("html2pdf.js")).default;

    // Show loading with countdown
    let secondsLeft = 10;
    Swal.fire({
      title: "Generating PDFs...",
      html: `<b>${secondsLeft}</b> seconds remaining.`,
      timer: secondsLeft * 1000,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        const b = Swal.getHtmlContainer().querySelector("b");
        const timerInterval = setInterval(() => {
          secondsLeft -= 1;
          b.textContent = secondsLeft;
          if (secondsLeft <= 0) clearInterval(timerInterval);
        }, 1000);
      },
    });

    const generatePDF = async ({ lang = "en" }) => {
      const isUrdu = lang === "ur";
      const title = isUrdu
        ? await translate("Consultant Duty Roster")
        : "Consultant Duty Roster";
      const hospitalName = isUrdu
        ? await translate("Rawalpindi Institute of Cardiology")
        : "Rawalpindi Institute of Cardiology";
      const subAddress = isUrdu
        ? await translate("Rawal Road, Rawalpindi")
        : "Rawal Road, Rawalpindi";

      const headers = ["Workstation", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const translatedHeaders = isUrdu
        ? await Promise.all(headers.map(translate))
        : headers;

      const bodyRows = await Promise.all(
        rosterData.map(async (entry) => {
          const fields = [
            entry.workstation,
            entry.monday,
            entry.tuesday,
            entry.wednesday,
            entry.thursday,
            entry.friday,
            entry.saturday,
          ];
          return isUrdu
            ? Promise.all(fields.map(translate))
            : fields;
        })
      );

      const pdfElement = document.createElement("div");
      pdfElement.style.display = "block";
      pdfElement.innerHTML = `
        <div style="font-family: ${
          isUrdu ? "'Noto Nastaliq Urdu', serif" : "'Segoe UI', Arial, sans-serif"
        }; direction: ${isUrdu ? "rtl" : "ltr"}; padding: 20px; color: #2c3e50;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
            <div style="width: 20%;"><img src="${leftLogoUrl}" style="height: 60px;" /></div>
            <div style="text-align: center; width: 60%;">
              <h2 style="margin: 0; font-weight: 700;">${hospitalName}</h2>
              <p style="margin: 2px 0; font-size: 13px; color: #555;">${subAddress}</p>
              <h4 style="margin: 6px 0; color: #444;">${title} – ${selectedSearchMonth}</h4>
            </div>
            <div style="width: 20%; text-align: ${isUrdu ? "left" : "right"};">
              <img src="${rightLogoUrl}" style="height: 60px;" />
            </div>
          </div>

          <table style="
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.08);
            border-radius: 10px;
            overflow: hidden;
          ">
            <thead>
              <tr style="background: linear-gradient(to right, #0052D4, #4364F7); color: #fff;">
                ${translatedHeaders
                  .map((h) => `<th style="padding: 12px;">${h}</th>`)
                  .join("")}
              </tr>
            </thead>
            <tbody>
              ${bodyRows
                .map(
                  (row, i) => `
                <tr style="background-color: ${i % 2 === 0 ? "#f4f6fb" : "#ffffff"};">
                  ${row
                    .map(
                      (cell) =>
                        `<td style="padding: 10px; border-top: 1px solid #dfe6f1;">${cell || ""}</td>`
                    )
                    .join("")}
                </tr>
              `
                )
                .join("")}
            </tbody>
          </table>


          <div style="margin-top: 80px; display: flex; justify-content: center; gap: 80px; font-size: 13px; align-items: flex-start;">
          <div style="text-align: center;">
            <div style="border-top: 1px solid #333; width: 220px; margin: auto; margin-bottom: 6px;"></div>
            <strong>Dr. Hamza Azhar Ghauri</strong><br />
            <span>Assistant Professor / Roster Incharge</span><br />
            <span>${hospitalName}</span>
          </div>
          <div style="text-align: center;">
            <div style="border-top: 1px solid #333; width: 220px; margin: auto; margin-bottom: 6px;"></div>
            <strong>Dr. Asim Javed</strong><br />
            <span>Associate Professor / HOD Cardiology</span><br />
            <span>${hospitalName}</span>
          </div>
        </div>


          <p style="text-align:center; margin-top: 40px; font-size: 10px; color: #888;">
            © ${new Date().getFullYear()} ${hospitalName}. All rights reserved.
          </p>
        </div>
      `;

      document.body.appendChild(pdfElement);

      await html2pdf()
        .set({
          margin: 0.5,
          filename: `Consultant_Roster_${selectedSearchMonth}_${lang}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
        })
        .from(pdfElement)
        .save();

      document.body.removeChild(pdfElement);
    };

    // Generate both files
    await generatePDF({ lang: "en" });
    await generatePDF({ lang: "ur" });

    Swal.fire({
      icon: "success",
      title: "Download Complete",
      text: "Both English and Urdu PDFs have been downloaded successfully.",
    });
  } catch (error) {
    console.error("PDF generation error:", error);
    Swal.fire({
      icon: "error",
      title: "Download Failed",
      text: "An error occurred while generating the PDF. Please try again.",
    });
  }
};


const [isEditMode, setIsEditMode] = useState(false);
const [editingId, setEditingId] = useState(null);


const handleEditRoster = (row) => {
  setWsForm({ ...row });
  setIsEditMode(true);
  setEditingId(row.id);
};

const handleWsFormSubmit = async (e) => {
  e.preventDefault();
    // Before axios.post
    if (!isEditMode) {
      const duplicate = rosterByMonth.some(
        (r) =>
          r.month === wsForm.month &&
          r.workstation.toLowerCase().trim() === wsForm.workstation.toLowerCase().trim()
      );

      if (duplicate) {
        Swal.fire({
          icon: "warning",
          title: "Duplicate Entry",
          text: `A roster already exists for "${wsForm.workstation}" in ${wsForm.month}.`,
        });
        return; // stop submission
      }
    }

  try {
    const url = isEditMode
      ? "https://ricgop.online/backend/updateOPDRoster.php"
      : "https://ricgop.online/backend/insertStationRoster.php";

    const payload = isEditMode ? { ...wsForm, id: editingId } : wsForm;

    console.log("Submitting:", payload); // Optional debug

    const res = await axios.post(url, payload);

    if (res.data.success) {
      Swal.fire({
        icon: "success",
        title: isEditMode ? "Roster Updated" : "Roster Submitted",
        text: "Roster has been successfully saved.",
      });

      // Refresh list
      fetchRosterByMonth(wsForm.month || selectedSearchMonth);

      // Reset form
      setWsForm({
        month: selectedSearchMonth || "",
        workstation: "",
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
      });

      setIsEditMode(false);
      setEditingId(null);
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: res.data.error || "Something went wrong.",
      });
    }
  } catch (err) {
    console.error("Submit error:", err);
    Swal.fire({
      icon: "error",
      title: "Submission Error",
      text: "Please try again later.",
    });
  }
};

const handleDeleteRoster = async (id) => {
  const confirm = await Swal.fire({
    title: "Are you sure?",
    text: "This roster entry will be permanently deleted.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
  });

  if (confirm.isConfirmed) {
    try {
      const res = await axios.post("https://ricgop.online/backend/deleteOPDRoster.php", { id });

      if (res.data.success) {
        Swal.fire("Deleted!", "Roster entry has been removed.", "success");
        fetchRosterByMonth(selectedSearchMonth);
      } else {
        Swal.fire("Error", res.data.error || "Deletion failed", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong while deleting.", "error");
    }
  }
};


const [postCathForm, setPostCathForm] = useState({
  date: "",
  day: "",
  shift: "Morning",
  role: "",
  name: "",
});
const [postCathSuggestions, setPostCathSuggestions] = useState([]);
const [highlightedPostCathIndex, setHighlightedPostCathIndex] = useState(-1);

const handlePostCathNameChange = (e) => {
  const value = e.target.value;
  setPostCathForm(prev => ({ ...prev, name: value }));
  setHighlightedPostCathIndex(-1);

  const lastWord = value.split(/[\s,]+/).pop().trim();
  if (lastWord.length >= 1) {
    axios
      .get(`https://ricgop.online/backend/getCathLabNames.php?name=${encodeURIComponent(lastWord)}`)
      .then(res => {
        setPostCathSuggestions(Array.isArray(res.data) ? res.data : []);
      })
      .catch(err => {
        console.error("Post Cath Lab suggestions error:", err);
        setPostCathSuggestions([]);
      });
  } else {
    setPostCathSuggestions([]);
  }
};

const handlePostCathKeyDown = (e) => {
  if (!postCathSuggestions.length) return;
  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedPostCathIndex(prev => (prev + 1) % postCathSuggestions.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedPostCathIndex(prev =>
      prev <= 0 ? postCathSuggestions.length - 1 : prev - 1
    );
  } else if (e.key === "Enter" && highlightedPostCathIndex >= 0) {
    e.preventDefault();
    handlePostCathSuggestionInsert(postCathSuggestions[highlightedPostCathIndex]);
  } else if (e.key === "Escape") {
    setPostCathSuggestions([]);
    setHighlightedPostCathIndex(-1);
  }
};

const handlePostCathSuggestionInsert = (name) => {
  const textarea = document.getElementById("postCathNameTextarea");
  const cursor = textarea.selectionStart;
  const currentText = postCathForm.name;
  const match = currentText.slice(0, cursor).match(/[\w\s]*$/);
  const insertStart = match ? cursor - match[0].length : cursor;
  const textBefore = currentText.slice(0, insertStart);
  const textAfter = currentText.slice(cursor);
  const sep = textBefore.trim().endsWith(",") || !textBefore.trim() ? "" : ", ";
  const newText = textBefore + sep + name + textAfter;
  setPostCathForm(prev => ({ ...prev, name: newText.trimStart() }));
  setPostCathSuggestions([]);
  setHighlightedPostCathIndex(-1);
  setTimeout(() => textarea.focus(), 0);
};

const [otForm, setOtForm] = useState({
  date: "",
  day: "",
  shift: "Morning",
  role: "",
  name: "",
});
const [otSuggestions, setOtSuggestions] = useState([]);
const [highlightedOtIndex, setHighlightedOtIndex] = useState(-1);


const handleOtNameChange = (e) => {
  const value = e.target.value;
  setOtForm(prev => ({ ...prev, name: value }));
  setHighlightedOtIndex(-1);

  const lastWord = value.split(/[\s,]+/).pop().trim();
  if (lastWord.length >= 1) {
    axios
      .get(`https://ricgop.online/backend/getOtNames.php?name=${encodeURIComponent(lastWord)}`)
      .then(res => {
        setOtSuggestions(Array.isArray(res.data) ? res.data : []);
      })
      .catch(err => {
        console.error("OT suggestions error:", err);
        setOtSuggestions([]);
      });
  } else {
    setOtSuggestions([]);
  }
};

const handleOtKeyDown = (e) => {
  if (!otSuggestions.length) return;
  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedOtIndex(prev => (prev + 1) % otSuggestions.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedOtIndex(prev => (prev <= 0 ? otSuggestions.length - 1 : prev - 1));
  } else if (e.key === "Enter" && highlightedOtIndex >= 0) {
    e.preventDefault();
    handleOtSuggestionInsert(otSuggestions[highlightedOtIndex]);
  } else if (e.key === "Escape") {
    setOtSuggestions([]);
    setHighlightedOtIndex(-1);
  }
};

const handleOtSuggestionInsert = (name) => {
  const textarea = document.getElementById("otNameTextarea");
  const cursor = textarea.selectionStart;
  const currentText = otForm.name;
  const match = currentText.slice(0, cursor).match(/[\w\s]*$/);
  const insertStart = match ? cursor - match[0].length : cursor;
  const textBefore = currentText.slice(0, insertStart);
  const textAfter = currentText.slice(cursor);
  const sep = textBefore.trim().endsWith(",") || !textBefore.trim() ? "" : ", ";
  const newText = textBefore + sep + name + textAfter;
  setOtForm(prev => ({ ...prev, name: newText.trimStart() }));
  setOtSuggestions([]);
  setHighlightedOtIndex(-1);
  setTimeout(() => textarea.focus(), 0);
};


const [erForm, setErForm] = useState({
  date: "", day: "", shift: "Morning", role: "", name: ""
});
const [erSuggestions, setErSuggestions] = useState([]);
const [highlightedErIndex, setHighlightedErIndex] = useState(-1);


const handleErNameChange = e => {
  const val = e.target.value;
  setErForm(prev => ({...prev, name: val}));
  setHighlightedErIndex(-1);

  const last = val.split(/[\s,]+/).pop().trim();
  if (last) {
    axios
      .get(`https://ricgop.online/backend/getErNames.php?name=${encodeURIComponent(last)}`)
      .then(res => {
        setErSuggestions(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => setErSuggestions([]));
  } else setErSuggestions([]);
};

const handleErKeyDown = e => {
  if (!erSuggestions.length) return;
  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedErIndex(prev => (prev + 1) % erSuggestions.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedErIndex(prev => prev <= 0 ? erSuggestions.length - 1 : prev - 1);
  } else if (e.key === "Enter" && highlightedErIndex >= 0) {
    e.preventDefault();
    insertErSuggestion(erSuggestions[highlightedErIndex]);
  } else if (e.key === "Escape") {
    setErSuggestions([]); setHighlightedErIndex(-1);
  }
};

const insertErSuggestion = name => {
  const ta = document.getElementById("erNameTextarea");
  const pos = ta.selectionStart;
  const text = erForm.name;
  const match = text.slice(0, pos).match(/[\w\s]*$/);
  const start = match ? pos - match[0].length : pos;
  const before = text.slice(0, start), after = text.slice(pos);
  const sep = before.trim().endsWith(",") || !before.trim() ? "" : ", ";
  const newText = before + sep + name + after;
  setErForm(prev => ({...prev, name: newText.trimStart()}));
  setErSuggestions([]); setHighlightedErIndex(-1);
  setTimeout(() => ta.focus(), 0);
};



// adding new features



  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setForm((prev) => ({ ...prev, date: today }));
  }, []);

  useEffect(() => {
  const isLoggedIn = localStorage.getItem("loggedIn");
  if (!isLoggedIn) {
    navigate("/roaster/login");
  }
}, []);

useEffect(() => {
  axios.get("https://ricgop.online/backend/getCathLabs.php")
    .then((res) => {
      setCathForm((prev) => ({
        ...prev,
        labOptions: res.data.length ? res.data : ["LAB A", "LAB B"]
      }));
    });
}, []);


// Part 1 Duty Roaster
// Part 1 Duty Roaster - states
const [dutySuggestions, setDutySuggestions] = useState([]);
const [highlightedDutyIndex, setHighlightedDutyIndex] = useState(-1);


const MySwal = withReactContent(Swal);

const handleDeleteDoctor = (nameToDelete, event) => {
  event.stopPropagation();

  MySwal.fire({
    title: `<div style="font-weight:600;">Delete <span style="color:#e63946;">"${nameToDelete}"</span>?</div>`,
    html: "<small>This action is <strong>permanent</strong> and cannot be undone.</small>",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#e63946",
    cancelButtonColor: "#6c757d",
    reverseButtons: true,
    backdrop: `rgba(0, 0, 0, 0.6)`,
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
    customClass: {
      popup: "rounded-5 shadow-lg p-4",
      title: "fs-5",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      // ✅ Show loading spinner
      MySwal.fire({
        title: "Deleting...",
        html: `<div class="spinner-border text-danger" role="status"></div>`,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        backdrop: `rgba(0, 0, 0, 0.2)`,
        customClass: {
          popup: "rounded-4 p-4",
        },
      });

      axios
        .post("https://ricgop.online/backend/deleteStaff.php", {
          name: nameToDelete,
        })
        .then((res) => {
          MySwal.close(); // ❌ Close loading spinner

          if (res.data.success) {
            setDutySuggestions((prev) =>
              prev.filter((doc) => doc.name !== nameToDelete)
            );

            // ✅ Play success sound
            const audio = new Audio("/sounds/success.mp3");
            audio.play().catch((err) => {
              console.warn("Audio playback failed:", err.message);
            });

            // ✅ Centered success toast
            MySwal.fire({
              toast: true,
              position: "center",
              icon: "success",
              title: `"${nameToDelete}" deleted successfully`,
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              customClass: {
                popup: "rounded-4 shadow bg-white px-4 py-3",
                title: "text-dark fw-semibold fs-6",
              },
              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            });
          } else {
            MySwal.fire("Error", res.data.message || "Failed to delete.", "error");
          }
        })
        .catch((err) => {
          MySwal.close();
          console.error(err);
          MySwal.fire("Error", "Server error while deleting.", "error");
        });
    }
  });
};

// Insert suggestion into input field
const insertDutySuggestion = (name) => {
  const input = document.querySelector('input[name="name"]');
  if (!input) return;

  const pos = input.selectionStart;
  const text = form.name;
  const match = text.slice(0, pos).match(/[\w\s]*$/);
  const start = match ? pos - match[0].length : pos;
  const before = text.slice(0, start);
  const after = text.slice(pos);
  const sep = before.trim().endsWith(",") || !before.trim() ? "" : ", ";
  const newText = before + sep + name + after;

  setForm(prev => ({ ...prev, name: newText.trimStart() }));
  setDutySuggestions([]);
  setHighlightedDutyIndex(-1);

  setTimeout(() => {
    input.focus();
    const caretPos = (before + sep + name).length;
    input.setSelectionRange(caretPos, caretPos);
  }, 0);
};

// On input change - fetch suggestions if input has at least 1 char
const handleDutyChange = (e) => {
  const { name, value } = e.target;
  setForm((prev) => ({ ...prev, [name]: value }));

  if (name === "name") {
    setHighlightedDutyIndex(-1); // Reset highlight

    if (value.length > 0) {  // Show suggestions for 1+ char
      axios
        .get(`https://ricgop.online/backend/getStaffList.php?name=${value}`)
        .then((res) => {
          if (Array.isArray(res.data)) {
            // Remove duplicate names
            const uniqueSuggestions = res.data.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.name === item.name)
            );
            setDutySuggestions(uniqueSuggestions);
          } else {
            setDutySuggestions([]);
          }
        })
        .catch(() => setDutySuggestions([]));
    } else {
      setDutySuggestions([]);
    }
  }
};

// Function to fetch and update staff details
const fetchStaffDetails = (selectedName) => {
  axios.get(`https://ricgop.online/backend/getStaff.php?name=${selectedName}`).then((res) => {
    if (res.data) {
      setForm((prev) => ({
        ...prev,
        contact: res.data.contact || "",
        section: res.data.section || "",
        onCall: res.data.on_call || "",
        role: res.data.role || "",
        shift: res.data.shift || "",
      }));
    }
  });
};



// Keyboard navigation on keyDown
const handleDutyKeyDown = (e) => {
  if (!dutySuggestions.length) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedDutyIndex((prev) => (prev + 1) % dutySuggestions.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedDutyIndex((prev) =>
      prev <= 0 ? dutySuggestions.length - 1 : prev - 1
    );
  } else if (e.key === "Enter" && highlightedDutyIndex >= 0) {
    e.preventDefault();
    const selectedName = dutySuggestions[highlightedDutyIndex]?.name;
    if (selectedName) {
      insertDutySuggestion(selectedName);
      fetchStaffDetails(selectedName);  // <-- Add this line here
    }
  } else if (e.key === "Escape") {
    setDutySuggestions([]);
    setHighlightedDutyIndex(-1);
  }
};

// When suggestion is clicked
const handleSuggestionClick = (selectedName) => {
  insertDutySuggestion(selectedName);
  // Fetch and update other fields if needed
  axios.get(`https://ricgop.online/backend/getStaff.php?name=${selectedName}`).then((res) => {
    if (res.data) {
      setForm((prev) => ({
        ...prev,
        contact: res.data.contact || "",
        section: res.data.section || "",
        onCall: res.data.on_call || "",
        role: res.data.role || "",
        shift: res.data.shift || "",
      }));
    }
  });
};

const handleDutySubmit = (e) => {
  e.preventDefault();

  axios.post("https://ricgop.online/backend/checkDuplicateDuty.php", form)
    .then((res) => {
      if (res.data.exists) {
        MySwal.fire({
          toast: true,
          position: "center",
          icon: "warning",
          title: "Duplicate duty already exists. Submission canceled.",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          customClass: {
            popup: "rounded-4 shadow bg-white px-4 py-3",
            title: "text-dark fw-semibold fs-6",
          },
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
      } else {
        // Optional: show spinner
        MySwal.fire({
          title: "Submitting...",
          html: `<div class="spinner-border text-primary" role="status"></div>`,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          backdrop: `rgba(0, 0, 0, 0.2)`,
          customClass: {
            popup: "rounded-4 p-4",
          },
        });

        axios.post("https://ricgop.online/backend/addDuty.php", form).then(() => {
          MySwal.close(); // Close loading spinner

          // ✅ Play success sound
          const audio = new Audio("/sounds/success.mp3");
          audio.play().catch(err => console.warn("Audio playback failed:", err.message));

          // ✅ Show success toast with doctor’s name
          MySwal.fire({
            toast: true,
            position: "center",
            icon: "success",
            title: `"${form.name}" duty added successfully`,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "rounded-4 shadow bg-white px-4 py-3",
              title: "text-dark fw-semibold fs-6",
            },
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          });

          // Reset form
          setForm({
            name: "",
            contact: "",
            role: "Doctor",
            section: "",
            shift: "",
            onCall: "",
            date: new Date().toISOString().split("T")[0],
          });
          setIsDateEditable(false);
          setSuggestions([]);
        });
      }
    })
    .catch(() => {
      MySwal.fire({
        toast: true,
        position: "center",
        icon: "error",
        title: "Something went wrong.",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "rounded-4 shadow bg-white px-4 py-3",
          title: "text-dark fw-semibold fs-6",
        },
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      });
    });
};


// Fire Fighter Form State
const [delegation, setDelegation] = useState("");
const [responsible, setResponsible] = useState("");

// Today's date as default
const getTodayDate = () => new Date().toISOString().split("T")[0];
const [date, setDate] = useState(getTodayDate()); // corresponds to 'created_at'

const handleFireFighterSubmit = () => {
  if (!delegation || !responsible || !date) {
    showWarningToast("All fields are required.");
    return;
  }

  fetch("https://ricgop.online/backend/addDelegation.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ delegation, responsible, created_at: date }),
  })
    .then((res) => res.json())
    .then(() => {
      showSuccessToast("Fire Fighter Delegation added!");
      setDelegation("");
      setResponsible("");
      setDate(getTodayDate());
    })
    .catch(() => showErrorToast("Failed to submit Fire Fighter form."));
};



  const handleAmsSubmit = (e) => {
  e.preventDefault();
  axios.post("https://ricgop.online/backend/addAms.php", amsForm)
    .then(() => {
      showSuccessToast("AMS Entry Added");
        setAmsForm({
        date: new Date().toISOString().split("T")[0],
        days: "",
        evening: ""
      });
    })
    .catch(() => showErrorToast("Failed to add AMS entry."));
};


const handleEveningChange = (e) => {
  const value = e.target.value;
  setAmsForm((prev) => ({ ...prev, evening: value }));
  setHighlightedIndex(-1); // reset selection
  
  const lastWord = value.split(/[\s,]+/).pop();

  if (lastWord.length >= 1) { // ✅ show suggestions from 1 character
    axios
      .get(`https://ricgop.online/backend/getAmsList.php?name=${lastWord}`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setAmsSuggestions(res.data); // assuming ["Dr. Shahid", "Dr. Sami"]
        } else {
          setAmsSuggestions([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching suggestions:", err);
        setAmsSuggestions([]);
      });
  } else {
    setAmsSuggestions([]);
  }
};

const handleKeyDown = (e) => {
  if (amsSuggestions.length === 0) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedIndex((prev) => (prev + 1) % amsSuggestions.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedIndex((prev) =>
      prev === 0 || prev === -1 ? amsSuggestions.length - 1 : prev - 1
    );
  } else if (e.key === "Enter") {
    if (highlightedIndex >= 0) {
      e.preventDefault();
      handleSuggestionInsert(amsSuggestions[highlightedIndex]);
    }
  } else if (e.key === "Escape") {
    setAmsSuggestions([]);
    setHighlightedIndex(-1);
  }
};

const handleSuggestionInsert = (name) => {
  const textarea = document.getElementById("amsEveningTextarea");
  const cursor = textarea.selectionStart;
  const currentText = amsForm.evening;

  const match = currentText.slice(0, cursor).match(/[\w\s]*$/);
  const insertStart = match ? cursor - match[0].length : cursor;

  const textBefore = currentText.slice(0, insertStart);
  const textAfter = currentText.slice(cursor);

  const separator =
    textBefore.trim().endsWith(",") || textBefore.trim() === "" ? "" : ", ";
  const newText = textBefore + separator + name + textAfter;

  setAmsForm((prev) => ({ ...prev, evening: newText.trimStart() }));
  setAmsSuggestions([]);
  setHighlightedIndex(-1);
  setTimeout(() => textarea.focus(), 0);
};


// VVIP Roaster

const handleVvipDoctorChange = (e) => {
  const value = e.target.value;
  setVvipForm((prev) => ({ ...prev, doctor: value }));
  setHighlightedIndex(-1);

  const lastWord = value.split(/[\s,]+/).pop();

  if (lastWord.length >= 1) {
    axios
      .get(`https://ricgop.online/backend/getVvipDoctors.php?name=${lastWord}`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setVvipSuggestions(res.data);
        } else {
          setVvipSuggestions([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching VVIP suggestions:", err);
        setVvipSuggestions([]);
      });
  } else {
    setVvipSuggestions([]);
  }
};

const handleVvipKeyDown = (e) => {
  if (vvipSuggestions.length === 0) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedIndex((prev) => (prev + 1) % vvipSuggestions.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedIndex((prev) =>
      prev === 0 || prev === -1 ? vvipSuggestions.length - 1 : prev - 1
    );
  } else if (e.key === "Enter") {
    if (highlightedIndex >= 0) {
      e.preventDefault();
      handleVvipSuggestionInsert(vvipSuggestions[highlightedIndex]);
    }
  } else if (e.key === "Escape") {
    setVvipSuggestions([]);
    setHighlightedIndex(-1);
  }
};

const handleVvipSuggestionInsert = (name) => {
  const textarea = document.getElementById("vvipDoctorTextarea");
  const cursor = textarea.selectionStart;
  const currentText = vvipForm.doctor;

  const match = currentText.slice(0, cursor).match(/[\w\s]*$/);
  const insertStart = match ? cursor - match[0].length : cursor;

  const textBefore = currentText.slice(0, insertStart);
  const textAfter = currentText.slice(cursor);

  const separator =
    textBefore.trim().endsWith(",") || textBefore.trim() === "" ? "" : ", ";
  const newText = textBefore + separator + name + textAfter;

  setVvipForm((prev) => ({ ...prev, doctor: newText.trimStart() }));
  setVvipSuggestions([]);
  setHighlightedIndex(-1);
  setTimeout(() => textarea.focus(), 0);
};




const handleCathLabSubmit = (e) => {
  e.preventDefault();

  const payload = {
    date: cathForm.date,
    days: cathForm.days,
    lab: cathForm.lab,
    labData: cathForm.labData,
    listUncharges: cathForm.listUncharges,
    adminInCharge: cathForm.adminInCharge,
  };

  axios
    .post("https://ricgop.online/backend/addCathLab.php", payload)
    .then((res) => {
      if (res.data.success) {
        showSuccessToast("Cath Lab Roaster Submitted");
        setCathForm((prev) => ({
          ...prev,
          days: "",
          lab: "LAB A",
          labData: "",
          listUncharges: "",
          adminInCharge: "",
          newLab: ""
        }));
      } else {
        showErrorToast("Error: " + (res.data.error || "Failed to submit"));
      }
    })
    .catch((err) => {
      showErrorToast("Network error or server unreachable");
      console.error(err);
    });
};

const handleAddNewLab = () => {
  const newLab = cathForm.newLab.trim();
  if (!newLab) return;

  axios.post("https://ricgop.online/backend/addCathLabName.php", { name: newLab })
    .then((res) => {
      if (res.data.success) {
        setCathForm((prev) => ({
          ...prev,
          labOptions: [...prev.labOptions, newLab],
          newLab: "",
          lab: newLab,
        }));
        showSuccessToast("New lab added");
      } else {
        showErrorToast("Could not add lab: " + res.data.error);
      }
    })
    .catch(() => {
      showErrorToast("Failed to add lab");
    });
};


// const handleVvipSubmit = async (e) => {
//   e.preventDefault();
//   try {
//     const response = await axios.post("https://ricgop.online/backend/addVvipRoaster.php", vvipForm);

//     if (response.data.success) {
//       showSuccessToast("VVIP Roaster submitted successfully");
//       setVvipForm({ date: "", day: "", shift: "", doctor: "" });
//     } else {
//       showErrorToast("Failed to submit VVIP Roaster");
//     }
//   } catch (error) {
//     console.error("Error submitting:", error);
//     showErrorToast("Server error. Please try again.");
//   }
// };






const showSuccessToast = (message) =>
  toast.success(
    <div className="d-flex align-items-center">
      <FaCheckCircle size={20} className="text-success me-3" />
      <div>
        <strong className="d-block">Success</strong>
        <span>{message}</span>
      </div>
    </div>,
    {
      position: "top-right",
      autoClose: 1000,
      className: "fs-6 px-3 py-2 rounded-3 bg-light border-start border-5 border-success shadow-sm",
    }
  );

const showErrorToast = (message) =>
  toast.error(
    <div className="d-flex align-items-center">
      <FaTimesCircle size={20} className="text-danger me-3" />
      <div>
        <strong className="d-block">Error</strong>
        <span>{message}</span>
      </div>
    </div>,
    {
      position: "top-right",
      autoClose: 1000,
      className: "fs-6 px-3 py-2 rounded-3 bg-light border-start border-5 border-danger shadow-sm",
    }
  );

const showWarningToast = (message) =>
  toast.warning(
    <div className="d-flex align-items-center">
      <FaExclamationTriangle size={20} className="text-warning me-3" />
      <div>
        <strong className="d-block">Warning</strong>
        <span>{message}</span>
      </div>
    </div>,
    {
      position: "top-right",
      autoClose: 1000,
      className: "fs-6 px-3 py-2 rounded-3 bg-light border-start border-5 border-warning shadow-sm",
    }
  );




   useEffect(() => {
    const dropdown = document.querySelector(".dropdown");

    const showDropdown = () => {
      if (window.innerWidth >= 992) { // Only hover on desktop
        dropdown.classList.add("show");
        dropdown.querySelector(".dropdown-menu").classList.add("show");
      }
    };

    const hideDropdown = () => {
      dropdown.classList.remove("show");
      dropdown.querySelector(".dropdown-menu").classList.remove("show");
    };

    dropdown.addEventListener("mouseenter", showDropdown);
    dropdown.addEventListener("mouseleave", hideDropdown);

    return () => {
      dropdown.removeEventListener("mouseenter", showDropdown);
      dropdown.removeEventListener("mouseleave", hideDropdown);
    };
  }, []);

 useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (storedUser?.email === "radiology@ricgop.online") {
      // Radiology user: show only their roster
      const filtered = allRosters.filter(r => r.value === "radiologyRoster");
      setRosters(filtered);
      setSelection("radiologyRoster");
    } else {
      // Everyone else (roaster, fire, etc.): show all
      setRosters(allRosters);
    }
  }, []); // ✅ runs only once
  return (
    <div>
       <nav className="navbar navbar-expand-lg bg-white shadow-sm px-4 py-3 mb-4 rounded-bottom-4">
      <div className="container-fluid">
        <a className="navbar-brand fw-bold text-primary fs-4" href="/">
          🏥 RIC Duty Panel
        </a>

        {/* Toggle button for mobile */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto align-items-center gap-lg-3 mt-3 mt-lg-0">

            {/* 🔽 Roasters Dropdown */}
            <li className="nav-item dropdown">
              <button
                className="btn btn-outline-secondary dropdown-toggle rounded-3 w-100"
                type="button"
                id="roastersDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                📁 Roasters
              </button>
              <ul className="dropdown-menu" aria-labelledby="roastersDropdown">
                <li>
                  <a className="dropdown-item" href="/entry/roaster/dutylist">Part 1 Duty Roaster</a>
                </li>
                <li>
                  <a className="dropdown-item" href="/entry/roaster/ams">AMS Roaster</a>
                </li>
                <li>
                  <a className="dropdown-item" href="/entry/roaster/vvip">VVIP Movement Roaster</a>
                </li>
              </ul>
            </li>

            {/* 📋 Duty Forms */}
            <li className="nav-item">
              <button
                className="btn btn-outline-primary rounded-3 w-100"
                onClick={() => window.location.href = "/entry/roaster/dutyform"}
              >
                📋 Duty Forms
              </button>
            </li>

            {/* 🚪 Logout */}
            <li className="nav-item">
              <button
                className="btn btn-outline-danger rounded-3 w-100"
                onClick={() => {
                  localStorage.clear();
                  window.location.href = "/roaster/login";
                }}
              >
                🚪 Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>

      {/* 🔽 Main Form Container */}
      <div className="container py-5">
     <div className="text-center mb-5">
      <h2 className="fw-bold mb-3">🚨 Select Roster</h2>

      <select
        className="form-select form-select-lg w-auto mx-auto shadow rounded-4"
        value={selection}
        onChange={(e) => setSelection(e.target.value)}
        disabled={rosters.length === 1} // lock if only one option
      >
        <option value="">-- Select --</option>
        {rosters.map((roster, index) => (
          <option
            key={roster.value}
            value={roster.value}
            disabled={roster.disabled}
          >
            {index + 1}. {roster.label}
          </option>
        ))}
      </select>

      {selection && (
        <p className="mt-3 text-muted">
          Selected Roster: <strong>{selection}</strong>
        </p>
      )}
    </div>


        {/* 🩺 Doctor Form */}
        {selection === "Doctor" && (
          <form
            onSubmit={handleDutySubmit}
            className="p-5 shadow rounded-5 bg-white mx-auto"
            style={{ maxWidth: 950 }}
          >
            <div className="row g-4">
           <div className="col-md-6 position-relative">
  <label className="form-label">
    <FaUserMd className="me-2" /> Full Name
  </label>
  <input
    type="text"
    name="name"
    className="form-control"
    placeholder="Type to search..."
    value={form.name}
    onChange={handleDutyChange}
    onKeyDown={handleDutyKeyDown}
    autoComplete="off"
    required
  />
  
  {/* Place suggestions here */}
{dutySuggestions.length > 0 && (
  <ul
    className="position-absolute w-100 mt-2 list-unstyled bg-white shadow rounded-3 z-3 border border-light"
    style={{
      maxHeight: 220,
      overflowY: "auto",
      padding: 0,
    }}
  >
    {dutySuggestions.map((s, i) => (
      <li
        key={i}
        className={`d-flex align-items-center justify-between px-3 py-2 ${
          i === highlightedDutyIndex
            ? "bg-primary text-white"
            : "bg-white text-dark"
        }`}
        style={{
          cursor: "pointer",
          transition: "background 0.2s ease",
          borderBottom:
            i !== dutySuggestions.length - 1 ? "1px solid #f1f1f1" : "none",
        }}
        onClick={() => handleSuggestionClick(s.name)}
        onMouseEnter={() => setHighlightedDutyIndex(i)}
      >
        <span className="flex-grow-1 fw-medium">{s.name}</span>
        <button
          type="button"
          className={`btn btn-sm ${
            i === highlightedDutyIndex ? "btn-light" : "btn-outline-danger"
          } border-0 ms-2 rounded-circle d-flex align-items-center justify-content-center`}
          style={{
            width: 24,
            height: 24,
            fontSize: "1rem",
            lineHeight: "1",
          }}
          onClick={(e) => handleDeleteDoctor(s.name, e)}
        >
          &times;
        </button>
      </li>
    ))}
  </ul>
)}
</div>

              <div className="col-md-6">
                <label className="form-label">
                  <FaPhone className="me-2" /> Contact
                </label>
                <input
                  type="text"
                  name="contact"
                  className="form-control"
                  value={form.contact}
                  onChange={handleDutyChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  <FaUserTag className="me-2" /> Role
                </label>
                <select
                  name="role"
                  className="form-select"
                  value={form.role}
                  onChange={handleDutyChange}
                >
                  <option>Doctor</option>
                  <option>Nurse</option>
                  <option>Ward Boy</option>
                  <option>Rapid Response Team Ground Floor</option>
                  <option>Rapid Response Team First Floor</option>
                  <option>Other</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  <FaClipboardList className="me-2" /> Section
                </label>
                <input
                  type="text"
                  name="section"
                  className="form-control"
                  value={form.section}
                  onChange={handleDutyChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  <FaClock className="me-2" /> Shift
                </label>
                <select
                  name="shift"
                  className="form-select"
                  value={form.shift}
                  onChange={handleDutyChange}
                >
                  <option value="">Select Shift</option>
                  <option>Morning</option>
                  <option>Evening</option>
                  <option>Night</option>
                  <option>24-Hour</option>
                  <option>On Call</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label d-flex justify-content-between">
                  <span>
                    <FaCalendarAlt className="me-2" /> Date
                  </span>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isDateEditable}
                    onChange={() => setIsDateEditable(!isDateEditable)}
                  />
                </label>
                <input
                  type="date"
                  name="date"
                  className="form-control"
                  value={form.date}
                  onChange={handleDutyChange}
                  disabled={!isDateEditable}
                />
              </div>

              <div className="col-md-12">
                <label className="form-label">
                  <FaUserCheck className="me-2" /> On Call Duties
                </label>
                <textarea
                  name="onCall"
                  rows="3"
                  className="form-control"
                  value={form.onCall}
                  onChange={handleDutyChange}
                />
              </div>

              <div className="col-12 text-end mt-4">
                <button
                  type="submit"
                  className="btn btn-primary px-5 rounded-4"
                >
                  ➕ Submit Duty
                </button>
              </div>
            </div>
          </form>
        )}

       {/* 🔥 Fire Fighter Form */}
{selection === "FireFighter" && (
  <div
    className="p-5 shadow bg-light rounded-5 mx-auto"
    style={{ maxWidth: 700 }}
  >
    <h4 className="text-center mb-4 text-danger">
      <FaFireExtinguisher /> Fire Fighting Team Form
    </h4>

    <div className="mb-3">
      <label className="form-label">
        <FaClipboardList className="me-2" /> Delegation Field
      </label>
      <input
        type="text"
        className="form-control"
        value={delegation}
        onChange={(e) => setDelegation(e.target.value)}
        placeholder="e.g., Fire Drill Coordination"
      />
    </div>

    <div className="mb-3">
      <label className="form-label">
        <FaUserTie className="me-2" /> Responsible Person
      </label>
      <textarea
        className="form-control"
        value={responsible}
        onChange={(e) => setResponsible(e.target.value)}
        rows="3"
        placeholder="e.g., John Doe"
      />
    </div>

    <div className="mb-4">
  <label className="form-label">📅 Date</label>
  <input
    type="date"
    className="form-control"
    value={date}
    onChange={(e) => setDate(e.target.value)}
  />
</div>

    <div className="text-end">
      <button
        className="btn btn-danger px-4 rounded-4"
        onClick={handleFireFighterSubmit}
      >
        Submit
      </button>
    </div>
  </div>
)}

        {/* 📘 AMS Form */}
{selection === "AMS" && (
  <div className="p-5 shadow bg-white rounded-5 mx-auto" style={{ maxWidth: 700 }}>
    <h4 className="text-center mb-4 text-primary">
      📘 AMS Evening Entry
    </h4>
    <form onSubmit={handleAmsSubmit}>
      <div className="mb-3">
        <label className="form-label">Date</label>
        <input
          type="date"
          className="form-control"
          value={amsForm.date}
          onChange={(e) => setAmsForm({ ...amsForm, date: e.target.value })}
          required
        />
      </div>
        <div className="mb-3">
          <label className="form-label">Days</label>
          <select
            className="form-select"
            value={amsForm.days}
            onChange={(e) => setAmsForm({ ...amsForm, days: e.target.value })}
            required
          >
            <option value="">Select a day</option>
            <option value="Monday">Monday</option>
            <option value="Tuesday">Tuesday</option>
            <option value="Wednesday">Wednesday</option>
            <option value="Thursday">Thursday</option>
            <option value="Friday">Friday</option>
            <option value="Saturday">Saturday</option>
            <option value="Sunday">Sunday</option>
          </select>
        </div>

     <div className="mb-4 position-relative">
  <label className="form-label">AMS Evening</label>
  <textarea
    id="amsEveningTextarea"
    className="form-control"
    rows="3"
    value={amsForm.evening}
    onChange={handleEveningChange}
    onKeyDown={handleKeyDown}
    placeholder="Type doctor's name..."
    autoComplete="off"
  ></textarea>

  {amsSuggestions.length > 0 && (
    <ul
      className="list-group position-absolute w-100 z-3 mt-1"
      style={{ maxHeight: 200, overflowY: "auto" }}
    >
      {amsSuggestions.map((name, index) => {
        const lastWord = amsForm.evening.split(/[\s,]+/).pop();
        const regex = new RegExp(`(${lastWord})`, "gi");
        const highlighted = name.replace(
          regex,
          "<strong class='text-primary'>$1</strong>"
        );

        return (
          <li
            key={index}
            className={`list-group-item list-group-item-action ${
              index === highlightedIndex ? "active" : ""
            }`}
            onClick={() => handleSuggestionInsert(name)}
            dangerouslySetInnerHTML={{ __html: highlighted }}
            style={{ cursor: "pointer" }}
          ></li>
        );
      })}
    </ul>
  )}
</div>

      <div className="text-end">
        <button type="submit" className="btn btn-primary px-4 rounded-4">
          ➕ Submit AMS
        </button>
      </div>
    </form>
  </div>
)}


{selection === "CathLab" && (
  <div className="p-5 shadow bg-white rounded-5 mx-auto" style={{ maxWidth: 700 }}>
    <h4 className="text-center mb-4 text-primary">🧪 Cath Lab Roaster</h4>
    <form
      onSubmit={(e) => {
        e.preventDefault();
        axios.post("https://ricgop.online/backend/addCathLab.php", cathForm)
          .then(() => {
            showSuccessToast("Cath Lab Roaster Submitted");
            setCathForm((prev) => ({
              ...prev,
              days: "",
              lab: "LAB A",
              listUncharges: "",
              adminInCharge: "",
              newLab: ""
            }));
          })
          .catch(() => showErrorToast("Failed to submit Cath Lab Roaster"));
      }}
    >
      <div className="mb-3">
        <label className="form-label">Date</label>
        <input
          type="date"
          className="form-control"
          value={cathForm.date}
          onChange={(e) => setCathForm({ ...cathForm, date: e.target.value })}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Days</label>
        <input
          type="text"
          className="form-control"
          value={cathForm.days}
          onChange={(e) => setCathForm({ ...cathForm, days: e.target.value })}
          required
        />
      </div>
   <div className="mb-3">
  <label className="form-label">Select Lab</label>
  <select
    className="form-select"
    value={cathForm.lab}
    onChange={(e) => setCathForm({ ...cathForm, lab: e.target.value })}
  >
    {cathForm.labOptions.map((lab, i) => (
      <option key={i} value={lab}>{lab}</option>
    ))}
  </select>
  <div className="input-group mt-2">
    <input
      type="text"
      className="form-control"
      placeholder="Add new lab..."
      value={cathForm.newLab}
      onChange={(e) => setCathForm({ ...cathForm, newLab: e.target.value })}
    />
    <button
      className="btn btn-outline-secondary"
      type="button"
      onClick={handleAddNewLab}
    >
      ➕ Add
    </button>
  </div>
</div>

{/* 🆕 LAB-SPECIFIC TEXTAREA */}
<div className="mb-3">
  <label className="form-label">{cathForm.lab} Duties</label>
  <textarea
    className="form-control"
    rows="3"
    value={cathForm.labData}
    onChange={(e) => setCathForm({ ...cathForm, labData: e.target.value })}
    placeholder={`Enter details for ${cathForm.lab}...`}
  />
</div>

      <div className="mb-3">
        <label className="form-label">List Uncharges</label>
        <textarea
          className="form-control"
          rows="3"
          value={cathForm.listUncharges}
          onChange={(e) => setCathForm({ ...cathForm, listUncharges: e.target.value })}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Cath-lab Administrative In-charge</label>
        <input
          type="text"
          className="form-control"
          value={cathForm.adminInCharge}
          onChange={(e) => setCathForm({ ...cathForm, adminInCharge: e.target.value })}
        />
      </div>
      <div className="text-end">
    <button type="submit" className="btn btn-primary px-4 rounded-4">
      ➕ Submit Cath Lab
    </button>
  </div>
    </form>
  </div>
)}


{selection === "VVIP" && (
  <div className="p-5 shadow bg-white rounded-5 mx-auto" style={{ maxWidth: 700 }}>
    <h4 className="text-center mb-4 text-danger">🚨 VVIP Movement Roaster Entry</h4>
  <form
  onSubmit={async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post("https://ricgop.online/backend/insertVvip.php", vvipForm);
      if (response.data.success) {
        // ✅ Show success toast
        showSuccessToast(`${vvipForm.shift} duty submitted for ${vvipForm.date}`);

        // Auto-progression logic
        const shiftOrder = ["Morning", "Evening", "DMS Night"];
        const currentShiftIndex = shiftOrder.indexOf(vvipForm.shift);

        if (currentShiftIndex < 2) {
          // Move to next shift
          setVvipForm((prev) => ({
            ...prev,
            shift: shiftOrder[currentShiftIndex + 1],
            doctor: "",
          }));
        } else {
          // All shifts done — go to next date
          const currentDate = new Date(vvipForm.date);
          currentDate.setDate(currentDate.getDate() + 1);
          const nextDate = currentDate.toISOString().split("T")[0];
          const nextDay = currentDate.toLocaleDateString("en-US", {
            weekday: "long",
          });

          setVvipForm({
            date: nextDate,
            day: nextDay,
            shift: "Morning",
            doctor: "",
          });
        }
      } else {
        showErrorToast("❌ Failed to submit: " + response.data.error);
      }
    } catch (error) {
      console.error("Submission error:", error);
      showErrorToast("⚠️ Submission failed. Please try again.");
    }
  }}
>

      {/* Date (auto sets day) */}
      <div className="mb-3">
        <label className="form-label">Date</label>
        <input
          type="date"
          className="form-control"
          value={vvipForm.date}
          onChange={(e) => {
            const selectedDate = e.target.value;
            const dayName = new Date(selectedDate).toLocaleDateString("en-US", {
              weekday: "long",
            });
            setVvipForm((prev) => ({
              ...prev,
              date: selectedDate,
              day: dayName,
            }));
          }}
          required
        />
      </div>

      {/* Day (auto filled) */}
      <div className="mb-3">
        <label className="form-label">Day</label>
        <input
          type="text"
          className="form-control"
          value={vvipForm.day}
          disabled
        />
      </div>

      {/* Shift (readonly for auto progression) */}
      <div className="mb-3">
        <label className="form-label">Shift</label>
        <input
          type="text"
          className="form-control"
          value={vvipForm.shift}
          disabled
        />
      </div>

      {/* Doctor field */}
      <div className="mb-4 position-relative">
        <label className="form-label">Doctor Name</label>
        <textarea
          id="vvipDoctorTextarea"
          className="form-control"
          rows="3"
          value={vvipForm.doctor}
          onChange={handleVvipDoctorChange}
          onKeyDown={handleVvipKeyDown}
          placeholder="Type doctor's name..."
          autoComplete="off"
        ></textarea>

        {vvipSuggestions.length > 0 && (
          <ul
            className="list-group position-absolute w-100 z-3 mt-1"
            style={{ maxHeight: 200, overflowY: "auto" }}
          >
            {vvipSuggestions.map((name, index) => {
              const lastWord = vvipForm.doctor.split(/[\s,]+/).pop();
              const regex = new RegExp(`(${lastWord})`, "gi");
              const highlighted = name.replace(
                regex,
                "<strong class='text-danger'>$1</strong>"
              );

              return (
                <li
                  key={index}
                  className={`list-group-item list-group-item-action ${
                    index === highlightedIndex ? "active" : ""
                  }`}
                  onClick={() => handleVvipSuggestionInsert(name)}
                  dangerouslySetInnerHTML={{ __html: highlighted }}
                  style={{ cursor: "pointer" }}
                ></li>
              );
            })}
          </ul>
        )}
      </div>

      <div className="text-end">
        <button type="submit" className="btn btn-danger px-4 rounded-4">
          ➕ Submit {vvipForm.shift}
        </button>
      </div>
    </form>
  </div>
)}


{selection === "csw" && (
  <div className="p-5 shadow bg-white rounded-5 mx-auto" style={{ maxWidth: 700 }}>
    <h4 className="text-center mb-4 text-primary">🩺 Cardiac Surgery Ward Roaster Entry</h4>
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        try {
          const response = await axios.post("https://ricgop.online/backend/insertCsw.php", cswForm);
          if (response.data.success) {
            showSuccessToast(`${cswForm.role} added for ${cswForm.shift} shift on ${cswForm.date}`);
            setCswForm({
              date: "",
              day: "",
              shift: "Morning",
              role: "",
              name: "",
            });
          } else {
            showErrorToast("❌ Submission failed: " + response.data.error);
          }
        } catch (err) {
          console.error("CSW Error", err);
          showErrorToast("⚠️ Submission failed. Please try again.");
        }
      }}
    >
      {/* Date */}
      <div className="mb-3">
        <label className="form-label">Date</label>
        <input
          type="date"
          className="form-control"
          value={cswForm.date}
          onChange={(e) => {
            const selectedDate = e.target.value;
            const dayName = new Date(selectedDate).toLocaleDateString("en-US", {
              weekday: "long",
            });
            setCswForm((prev) => ({
              ...prev,
              date: selectedDate,
              day: dayName,
            }));
          }}
          required
        />
      </div>

      {/* Day */}
      <div className="mb-3">
        <label className="form-label">Day</label>
        <input
          type="text"
          className="form-control"
          value={cswForm.day}
          disabled
        />
      </div>

      {/* Shift */}
      <div className="mb-3">
        <label className="form-label">Shift</label>
        <select
          className="form-select"
          value={cswForm.shift}
          onChange={(e) =>
            setCswForm((prev) => ({ ...prev, shift: e.target.value }))
          }
          required
        >
          <option value="">-- Select Shift --</option>
          <option value="Morning">Morning</option>
          <option value="Evening">Evening</option>
          <option value="Night">Night</option>
        </select>
      </div>

      {/* Role */}
      <div className="mb-3">
        <label className="form-label">Role</label>
        <select
          className="form-select"
          value={cswForm.role}
          onChange={(e) =>
            setCswForm((prev) => ({ ...prev, role: e.target.value }))
          }
          required
        >
          <option value="">-- Select Role --</option>
          <option value="Doctor">Doctor</option>
          <option value="Nurse">Nurse</option>
          <option value="Ward Boy / Aya">Ward Boy / Aya</option>
          <option value="Janitorial Staff">Janitorial Staff</option>
        </select>
      </div>

      {/* Name Input */}
     <div className="mb-3 position-relative">
        <label className="form-label">Name</label>
        <textarea
          id="cswNameTextarea"
          className="form-control"
          rows="3"
          value={cswForm.name}
          onChange={handleCswNameChange}
          onKeyDown={handleCswKeyDown}
          placeholder={`Enter ${cswForm.role || "name"}...`}
          autoComplete="off"
          required
        ></textarea>

        {cswSuggestions.length > 0 && (
          <ul
            className="list-group position-absolute w-100 z-3 mt-1"
            style={{ maxHeight: 200, overflowY: "auto" }}
          >
            {cswSuggestions.map((name, index) => {
              const lastWord = cswForm.name.split(/[\s,]+/).pop();
              const regex = new RegExp(`(${lastWord})`, "gi");
              const highlighted = name.replace(
                regex,
                "<strong class='text-primary'>$1</strong>"
              );

              return (
                <li
                  key={index}
                  className={`list-group-item list-group-item-action ${
                    index === highlightedCswIndex ? "active" : ""
                  }`}
                  onClick={() => handleCswSuggestionInsert(name)}
                  dangerouslySetInnerHTML={{ __html: highlighted }}
                  style={{ cursor: "pointer" }}
                ></li>
              );
            })}
          </ul>
        )}
      </div>


      <div className="text-end">
        <button type="submit" className="btn btn-primary px-4 rounded-4">
          ➕ Submit Entry
        </button>
      </div>
    </form>
  </div>
)}


{selection === "gw" && (
  <div className="p-5 shadow bg-white rounded-5 mx-auto" style={{ maxWidth: 700 }}>
    <h4 className="text-center mb-4 text-success">🛏️ General Ward Roaster Entry</h4>
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        try {
          const response = await axios.post("https://ricgop.online/backend/insertGw.php", gwForm);
          if (response.data.success) {
            showSuccessToast(`${gwForm.role} added for ${gwForm.shift} shift on ${gwForm.date}`);
            setGwForm({ date: "", day: "", shift: "Morning", role: "", name: "" });
          } else {
            showErrorToast("❌ Submission failed: " + response.data.error);
          }
        } catch (err) {
          console.error("GW Error", err);
          showErrorToast("⚠️ Submission failed. Please try again.");
        }
      }}
    >
      {/* Date */}
      <div className="mb-3">
        <label className="form-label">Date</label>
        <input
          type="date"
          className="form-control"
          value={gwForm.date}
          onChange={(e) => {
            const selectedDate = e.target.value;
            const dayName = new Date(selectedDate).toLocaleDateString("en-US", {
              weekday: "long",
            });
            setGwForm((prev) => ({ ...prev, date: selectedDate, day: dayName }));
          }}
          required
        />
      </div>

      {/* Day */}
      <div className="mb-3">
        <label className="form-label">Day</label>
        <input type="text" className="form-control" value={gwForm.day} disabled />
      </div>

      {/* Shift */}
      <div className="mb-3">
        <label className="form-label">Shift</label>
        <select
          className="form-select"
          value={gwForm.shift}
          onChange={(e) => setGwForm((prev) => ({ ...prev, shift: e.target.value }))}
          required
        >
          <option value="">-- Select Shift --</option>
          <option value="Morning">Morning</option>
          <option value="Evening">Evening</option>
          <option value="Night">Night</option>
        </select>
      </div>

      {/* Role */}
      <div className="mb-3">
        <label className="form-label">Role</label>
        <select
          className="form-select"
          value={gwForm.role}
          onChange={(e) => setGwForm((prev) => ({ ...prev, role: e.target.value }))}
          required
        >
          <option value="">-- Select Role --</option>
          <option value="Doctor">Doctor</option>
          <option value="Nurse">Nurse</option>
          <option value="Ward Boy / Aya">Ward Boy / Aya</option>
          <option value="Janitorial Staff">Janitorial Staff</option>
        </select>
      </div>

      {/* Name input */}
      <div className="mb-3 position-relative">
        <label className="form-label">Name</label>
        <textarea
          id="gwNameTextarea"
          className="form-control"
          rows="3"
          value={gwForm.name}
          onChange={handleGwNameChange}
          onKeyDown={handleGwKeyDown}
          placeholder={`Enter ${gwForm.role || "name"}...`}
          autoComplete="off"
          required
        ></textarea>

        {gwSuggestions.length > 0 && (
          <ul className="list-group position-absolute w-100 z-3 mt-1" style={{ maxHeight: 200, overflowY: "auto" }}>
            {gwSuggestions.map((name, index) => {
              const lastWord = gwForm.name.split(/[\s,]+/).pop();
              const regex = new RegExp(`(${lastWord})`, "gi");
              const highlighted = name.replace(
                regex,
                "<strong class='text-success'>$1</strong>"
              );
              return (
                <li
                  key={index}
                  className={`list-group-item list-group-item-action ${index === highlightedGwIndex ? "active" : ""}`}
                  onClick={() => handleGwSuggestionInsert(name)}
                  dangerouslySetInnerHTML={{ __html: highlighted }}
                  style={{ cursor: "pointer" }}
                ></li>
              );
            })}
          </ul>
        )}
      </div>

      <div className="text-end">
        <button type="submit" className="btn btn-success px-4 rounded-4">
          ➕ Submit Entry
        </button>
      </div>
    </form>
  </div>
)}


{selection === "cathlab" && (
  <div className="p-5 shadow bg-white rounded-5 mx-auto" style={{ maxWidth: 700 }}>
    <h4 className="text-center mb-4 text-info">🧪 Post Cath Lab Roaster Entry</h4>
    <form onSubmit={async (e) => {
      e.preventDefault();
      try {
        const resp = await axios.post(
          "https://ricgop.online/backend/insertCathLab.php",
          postCathForm
        );
        if (resp.data.success) {
          showSuccessToast(`${postCathForm.role} added for ${postCathForm.shift} shift on ${postCathForm.date}`);
          setPostCathForm({ date: "", day: "", shift: "Morning", role: "", name: "" });
        } else {
          showErrorToast("❌ Submission failed: " + resp.data.error);
        }
      } catch (err) {
        console.error("Post Cath Lab error:", err);
        showErrorToast("⚠️ Submission failed. Please try again.");
      }
    }}>
      {/* Date */}
      <div className="mb-3">
        <label className="form-label">Date</label>
        <input type="date" className="form-control" value={postCathForm.date}
          onChange={(e) => {
            const sd = e.target.value;
            const dn = new Date(sd).toLocaleDateString("en-US", { weekday: "long" });
            setPostCathForm(prev => ({ ...prev, date: sd, day: dn }));
          }} required />
      </div>
      {/* Day */}
      <div className="mb-3">
        <label className="form-label">Day</label>
        <input type="text" className="form-control" value={postCathForm.day} disabled />
      </div>
      {/* Shift */}
      <div className="mb-3">
        <label className="form-label">Shift</label>
        <select className="form-select" value={postCathForm.shift}
          onChange={e => setPostCathForm(prev => ({ ...prev, shift: e.target.value }))}
          required>
          <option value="">-- Select Shift --</option>
          <option value="Morning">Morning</option>
          <option value="Evening">Evening</option>
          <option value="Night">Night</option>
        </select>
      </div>
      {/* Role */}
      <div className="mb-3">
        <label className="form-label">Role</label>
        <select className="form-select" value={postCathForm.role}
          onChange={e => setPostCathForm(prev => ({ ...prev, role: e.target.value }))}
          required>
     <option value="">-- Select Role --</option>
          <option value="Doctor">Doctor</option>
          <option value="Nurse">Nurse</option>
          <option value="Ward Boy / Aya">Ward Boy / Aya</option>
          <option value="Janitorial Staff">Janitorial Staff</option>
        </select>
      </div>
      {/* Name */}
      <div className="mb-3 position-relative">
        <label className="form-label">Name</label>
        <textarea id="postCathNameTextarea" className="form-control" rows="3"
          value={postCathForm.name}
          onChange={handlePostCathNameChange}
          onKeyDown={handlePostCathKeyDown}
          placeholder={`Enter ${postCathForm.role || "name"}...`}
          required />
        {postCathSuggestions.length > 0 && (
          <ul className="list-group position-absolute w-100 z-3 mt-1" style={{ maxHeight:200, overflowY:"auto" }}>
            {postCathSuggestions.map((n,i) => {
              const lw = postCathForm.name.split(/[\s,]+/).pop();
              const regex = new RegExp(`(${lw})`, "gi");
              const highlighted = n.replace(regex, "<strong class='text-info'>$1</strong>");
              return (
                <li key={i}
                  className={`list-group-item list-group-item-action ${i===highlightedPostCathIndex ? "active" : ""}`}
                  onClick={() => handlePostCathSuggestionInsert(n)}
                  dangerouslySetInnerHTML={{ __html: highlighted }}
                  style={{ cursor:"pointer" }} />
              );
            })}
          </ul>
        )}
      </div>
      {/* Submit */}
      <div className="text-end">
        <button type="submit" className="btn btn-info px-4 rounded-4">
          ➕ Submit Entry
        </button>
      </div>
    </form>
  </div>
)}


{selection === "otroaster" && (
  <div className="p-5 shadow bg-white rounded-5 mx-auto" style={{ maxWidth: 700 }}>
    <h4 className="text-center mb-4 text-success">🏥 OT Roaster Entry</h4>
    <form onSubmit={async (e) => {
      e.preventDefault();
      try {
        const resp = await axios.post("https://ricgop.online/backend/insertOtRoaster.php", otForm);
        if (resp.data.success) {
          showSuccessToast(`${otForm.role} added for ${otForm.shift} shift on ${otForm.date}`);
          setOtForm({ date: "", day: "", shift: "Morning", role: "", name: "" });
        } else {
          showErrorToast("❌ Submission failed: " + resp.data.error);
        }
      } catch (err) {
        console.error("OT Roaster error:", err);
        showErrorToast("⚠️ Submission failed. Please try again.");
      }
    }}>
      {/* Date */}
      <div className="mb-3">
        <label className="form-label">Date</label>
        <input type="date" className="form-control" value={otForm.date}
          onChange={(e) => {
            const sd = e.target.value;
            const dn = new Date(sd).toLocaleDateString("en-US", { weekday: "long" });
            setOtForm(prev => ({ ...prev, date: sd, day: dn }));
          }} required />
      </div>
      {/* Day */}
      <div className="mb-3">
        <label className="form-label">Day</label>
        <input type="text" className="form-control" value={otForm.day} disabled />
      </div>
      {/* Shift */}
      <div className="mb-3">
        <label className="form-label">Shift</label>
        <select className="form-select" value={otForm.shift}
          onChange={e => setOtForm(prev => ({ ...prev, shift: e.target.value }))}
          required>
          <option value="">-- Select Shift --</option>
          <option value="Morning">Morning</option>
          <option value="Evening">Evening</option>
          <option value="Night">Night</option>
        </select>
      </div>
      {/* Role */}
      <div className="mb-3">
        <label className="form-label">Role</label>
        <select className="form-select" value={otForm.role}
          onChange={e => setOtForm(prev => ({ ...prev, role: e.target.value }))}
          required>
          <option value="">-- Select Role --</option>
          <option value="Doctor">Doctor</option>
          <option value="Nurse">Nurse</option>
          <option value="Ward Boy / Aya">Ward Boy / Aya</option>
          <option value="Janitorial Staff">Janitorial Staff</option>
        </select>
      </div>
      {/* Name */}
      <div className="mb-3 position-relative">
        <label className="form-label">Name</label>
        <textarea id="otNameTextarea" className="form-control" rows="3"
          value={otForm.name}
          onChange={handleOtNameChange}
          onKeyDown={handleOtKeyDown}
          placeholder={`Enter ${otForm.role || "name"}...`}
          required />
        {otSuggestions.length > 0 && (
          <ul className="list-group position-absolute w-100 z-3 mt-1" style={{ maxHeight: 200, overflowY: "auto" }}>
            {otSuggestions.map((n, i) => {
              const lw = otForm.name.split(/[\s,]+/).pop();
              const regex = new RegExp(`(${lw})`, "gi");
              const highlighted = n.replace(regex, "<strong class='text-success'>$1</strong>");
              return (
                <li key={i}
                  className={`list-group-item list-group-item-action ${i === highlightedOtIndex ? "active" : ""}`}
                  onClick={() => handleOtSuggestionInsert(n)}
                  dangerouslySetInnerHTML={{ __html: highlighted }}
                  style={{ cursor: "pointer" }} />
              );
            })}
          </ul>
        )}
      </div>
      {/* Submit */}
      <div className="text-end">
        <button type="submit" className="btn btn-success px-4 rounded-4">
          ➕ Submit Entry
        </button>
      </div>
    </form>
  </div>
)}

{selection === "er" && (
  <div className="p-5 shadow bg-white rounded-5 mx-auto" style={{maxWidth:700}}>
    <h4 className="text-center mb-4 text-warning">🚨 Emergency Room Roaster Entry</h4>
    <form onSubmit={async e => {
      e.preventDefault();
      try {
        const resp = await axios.post(
          "https://ricgop.online/backend/insertErRoaster.php",
          erForm
        );
        if (resp.data.success) {
          showSuccessToast(`${erForm.role} assigned for ${erForm.shift} shift on ${erForm.date}`);
          setErForm({date:"",day:"",shift:"Morning",role:"",name:""});
        } else {
          showErrorToast("❌ Submission failed: "+resp.data.error);
        }
      } catch {
        showErrorToast("⚠️ Submission failed. Please try again.");
      }
    }}>
      {/* Date */}
      <div className="mb-3">
        <label className="form-label">Date</label>
        <input type="date" className="form-control" value={erForm.date}
          onChange={e => {
            const sd = e.target.value;
            setErForm(prev => ({
              ...prev,
              date: sd,
              day: new Date(sd).toLocaleDateString("en-US",{weekday:"long"})
            }));
          }} required />
      </div>
      {/* Day */}
      <div className="mb-3">
        <label className="form-label">Day</label>
        <input type="text" className="form-control" value={erForm.day} disabled />
      </div>
      {/* Shift */}
      <div className="mb-3">
        <label className="form-label">Shift</label>
        <select className="form-select" value={erForm.shift}
          onChange={e=>setErForm(prev=>({...prev,shift:e.target.value}))} required>
          <option value="">-- Select Shift --</option>
          <option value="Morning">Morning</option>
          <option value="Evening">Evening</option>
          <option value="Night">Night</option>
        </select>
      </div>
      {/* Role */}
      <div className="mb-3">
        <label className="form-label">Role</label>
        <select className="form-select" value={erForm.role}
          onChange={e=>setErForm(prev=>({...prev,role:e.target.value}))} required>
        <option value="">-- Select Role --</option>
          <option value="Doctor">Doctor</option>
          <option value="Nurse">Nurse</option>
          <option value="Ward Boy / Aya">Ward Boy / Aya</option>
          <option value="Janitorial Staff">Janitorial Staff</option>
        </select>
      </div>
      {/* Name */}
      <div className="mb-3 position-relative">
        <label className="form-label">Name</label>
        <textarea id="erNameTextarea" className="form-control" rows="3"
          value={erForm.name}
          onChange={handleErNameChange}
          onKeyDown={handleErKeyDown}
          placeholder={`Enter ${erForm.role || "name"}...`}
          required />
        {erSuggestions.length > 0 && (
          <ul className="list-group position-absolute w-100 z-3 mt-1" style={{maxHeight:200,overflowY:"auto"}}>
            {erSuggestions.map((n,i)=> {
              const lw = erForm.name.split(/[\s,]+/).pop();
              const h = n.replace(new RegExp(`(${lw})`,"gi"), "<strong class='text-warning'>$1</strong>");
              return (
                <li key={i}
                  className={`list-group-item list-group-item-action ${i===highlightedErIndex?"active":""}`}
                  onClick={()=>insertErSuggestion(n)}
                  dangerouslySetInnerHTML={{__html:h}}
                  style={{cursor:"pointer"}} />
              );
            })}
          </ul>
        )}
      </div>
      {/* Submit */}
      <div className="text-end">
        <button type="submit" className="btn btn-warning px-4 rounded-4">
          ➕ Submit Entry
        </button>
      </div>
    </form>
  </div>
)}

{selection === "cwo" && (
  <div className="p-4 bg-white rounded-5 shadow-lg mx-auto" style={{ maxWidth: 1000 }}>
    <h4 className="text-center mb-4 fw-bold text-primary">🩺 Consultant OPD Roster</h4>

    {/* 🔍 Search Past & Future Rosters */}
    <div className="row g-3 align-items-end mb-4">
      <div className="col-md-8">
        <label className="form-label fw-semibold">🔎 Search Roster by Month</label>
        <select
          className="form-select rounded-4 shadow-sm"
          value={selectedSearchMonth}
          onChange={(e) => {
            setSelectedSearchMonth(e.target.value);
            fetchRosterByMonth(e.target.value);
          }}
        >
          <option value="">-- Select Month --</option>
          {Array.from({ length: 42 }, (_, i) => {
            const date = new Date();
            date.setMonth(date.getMonth() - 6 + i);
            const label = date.toLocaleString("default", {
              month: "long",
              year: "numeric",
            });
            return (
              <option key={`${label}-${i}`} value={label}>
                {label}
              </option>
            );
          })}
        </select>
      </div>

      <div className="col-md-4 d-flex gap-2">
        <button
          className="btn btn-outline-success rounded-4 flex-fill shadow-sm"
          onClick={handleEmailRoster}
          disabled={!wsForm.workstation}
        >
          📤 Email Roster
        </button>
        <button
          className="btn btn-outline-primary rounded-4 flex-fill shadow-sm"
          onClick={handleDownloadRoster}
          disabled={!selectedSearchMonth}
        >
          📥 Download PDF
        </button>
      </div>
    </div>

    {/* 📝 Roster Form */}
    <form onSubmit={handleWsFormSubmit}>
      {/* Month & Workstation Row */}
      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <label className="form-label fw-semibold">📅 Roster Month</label>
          <select
            className="form-select rounded-4 shadow-sm"
            value={wsForm.month}
            onChange={(e) => setWsForm((prev) => ({ ...prev, month: e.target.value }))}
            required
            disabled={isEditMode}
          >
            {Array.from({ length: 24 }, (_, i) => {
              const date = new Date();
              date.setMonth(date.getMonth() + i);
              const label = date.toLocaleString("default", { month: "long", year: "numeric" });
              return (
                <option key={`${label}-${i}`} value={label}>
                  {label}
                </option>
              );
            })}
          </select>
        </div>

        <div className="col-md-6">
          <label className="form-label fw-semibold">🏥 Workstation</label>
          <input
            type="text"
            className="form-control rounded-4 shadow-sm"
            placeholder="Enter workstation name"
            name="workstation"
            value={wsForm.workstation}
            onChange={handleWsChange}
            required
          />
        </div>
      </div>

      {/* 🗓️ Day Grid */}
      <div className="row g-4">
        {["monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].map((day) => (
          <div className="col-md-6 position-relative" key={day}>
            <label className="form-label fw-semibold">
              {dayIcons[day]} <span className="text-capitalize">{day}</span>
            </label>
            <textarea
              id={`ws-${day}`}
              className="form-control rounded-4 shadow-sm"
              rows="2"
              name={day}
              placeholder="Enter doctor names, separated by commas"
              value={wsForm[day]}
              onChange={handleWsChange}
              onFocus={() => setFocusedDay(day)}
              onKeyDown={handleWsKeyDown}
              required
            ></textarea>

            {focusedDay === day && wsSuggestions.length > 0 && (
              <ul
                className="list-group position-absolute w-100 z-3 mt-1 rounded-3 shadow"
                style={{ maxHeight: 180, overflowY: "auto" }}
              >
                {wsSuggestions.map((name, index) => {
                  const lastWord = wsForm[day].split(/[\s,]+/).pop();
                  const regex = new RegExp(`(${lastWord})`, "gi");
                  const highlighted = name.replace(
                    regex,
                    "<strong class='text-success'>$1</strong>"
                  );
                  return (
                    <li
                      key={index}
                      className={`list-group-item list-group-item-action ${
                        index === highlightedWsIndex ? "active" : ""
                      }`}
                      onClick={() => handleWsSuggestionInsert(name)}
                      dangerouslySetInnerHTML={{ __html: highlighted }}
                      style={{ cursor: "pointer" }}
                    ></li>
                  );
                })}
              </ul>
            )}
          </div>
        ))}
      </div>

      {/* ✅ Submit & Cancel */}
      <div className="text-end mt-5 d-flex justify-content-end gap-3">
        {isEditMode && (
          <button
            type="button"
            className="btn btn-outline-secondary px-4 py-2 rounded-4 shadow-sm"
            onClick={() => {
              setIsEditMode(false);
              setEditingId(null);
              setWsForm({
                month: selectedSearchMonth || "",
                workstation: "",
                monday: "",
                tuesday: "",
                wednesday: "",
                thursday: "",
                friday: "",
                saturday: "",
              });
            }}
          >
            ❌ Cancel Edit
          </button>
        )}
        <button type="submit" className="btn btn-primary px-4 py-2 rounded-4 shadow-sm">
          {isEditMode ? "🔄 Update Roster" : "📥 Submit Roster"}
        </button>
      </div>
    </form>
  </div>
)}


{rosterByMonth.length > 0 && (
  <div className="table-responsive mt-5">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="text-primary fw-bold mb-0">
        📋 Editable Roster for "<span className="text-dark">{selectedSearchMonth}</span>"
      </h5>
    </div>

    <table className="table table-striped table-bordered shadow-sm rounded-4 overflow-hidden">
      <thead className="table-primary text-dark text-center align-middle">
        <tr style={{ verticalAlign: "middle" }}>
          <th className="py-3">🏥 Workstation</th>
          <th>📅 Mon</th>
          <th>📅 Tue</th>
          <th>📅 Wed</th>
          <th>📅 Thu</th>
          <th>📅 Fri</th>
          <th>📅 Sat</th>
          <th className="text-center">⚙️ Actions</th>
        </tr>
      </thead>
      <tbody className="text-center align-middle">
        {rosterByMonth.map((row, i) => (
          <tr key={i}>
            <td className="fw-semibold text-start ps-3">{row.workstation}</td>
            <td>{row.monday}</td>
            <td>{row.tuesday}</td>
            <td>{row.wednesday}</td>
            <td>{row.thursday}</td>
            <td>{row.friday}</td>
            <td>{row.saturday}</td>
            <td>
              <div className="d-flex justify-content-center gap-2">
                <button
                  className="btn btn-outline-warning btn-sm rounded-pill px-3"
                  onClick={() => handleEditRoster(row)}
                >
                  ✏️ Edit
                </button>
                <button
                  className="btn btn-outline-danger btn-sm rounded-pill px-3"
                  onClick={() => handleDeleteRoster(row.id)}
                >
                  🗑️ Delete
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}


{wsPreview && (
  <div className="mt-4 p-3 border rounded shadow-sm bg-light">
    <h5 className="text-primary mb-3">📋 Submitted Roster Summary</h5>
    <p><strong>Month:</strong> {wsPreview.month}</p>
    <p><strong>Workstation:</strong> {wsPreview.workstation}</p>
    {["monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].map(day => (
      <p key={day}>
        <strong>{dayIcons[day]} {day.charAt(0).toUpperCase() + day.slice(1)}:</strong><br />
        {wsPreview[day] || <em>No entry</em>}
      </p>
    ))}
  </div>
)}

{selection === "pgt" && <PGTDutyStationForm />}  {/* ✅ NEW */}
{selection === "cwr" && <ConsultantWardRoster />}  {/* ✅ NEW */}
{selection === "cer" && <ConsultantEchoRoster />}  {/* ✅ NEW */}
{selection === "lnsr" && <RICLongShortRoster />}  {/* ✅ NEW */}
{selection === "RICCathLab" && <RosterForm />}  {/* ✅ NEW */}
{selection ==="ITCWardboyAya" && <WardBoyAyaITC />} {/* ✅ NEW */}

{selection ==="itcWardaya" && <WardBoyAyaRoster />} {/* ✅ NEW */}
{selection ==="cpcroster" && <RICLastSaturdayRoster />} {/* ✅ NEW */}
{selection ==="dwhdu2" && <HDU2wardroster />} {/* ✅ NEW */}
{selection ==="wardboyaya" && <WardboyAya />} {/* ✅ NEW */}
{selection ==="gwccupc" && <GeneralWardCCU1PostCath />} {/* ✅ NEW */}
{selection ==="gwar" && <GynaeWardAya />} {/* ✅ NEW */}
{selection ==="wbagwr" && <WardboyAyaGeneralWard />} {/* ✅ NEW */}
{selection ==="bgdr" && <BiogasesDepartmentRoster />} {/* ✅ NEW */}
{selection ==="wbaitc3" && <ITC3wardBoyAya />} {/* ✅ NEW */}
{selection ==="pdr" && <PathologyDepartmentRoster />} {/* ✅ NEW */}
{selection ==="driverRoster" && <DriverRoster />} {/* ✅ NEW */}
{selection ==="CSWRoster" && <CardiacSurgeryWardRoster />} {/* ✅ NEW */}
{selection ==="mdhr" && <MaleDoctorHostelRoster />} {/* ✅ NEW */}
{selection ==="physioRoster" && <PhysiotherapyRoster />} {/* ✅ NEW */}
{selection ==="radiologyRoster" && <RadiologyDepartment />} {/* ✅ NEW */}
{selection ==="filterTesting" && <FilterTesting />} {/* ✅ NEW */}
{selection ==="tdr" && <TechincalDept />} {/* ✅ NEW */}
{selection ==="bmdr" && <BiomedicalDepartment />} {/* ✅ NEW */}
{selection ==="ettdr" && <EttDepartment />} {/* ✅ NEW */}
{selection ==="hvacdr" && <HvacDepartment />} {/* ✅ NEW */}
{selection ==="ecgdr" && <EcgDepartment />} {/* ✅ NEW */}
{selection ==="cssdr" && <CssdDepartment />} {/* ✅ NEW */}
{selection ==="sdr" && <SurgicalDepartment />} {/* ✅ NEW */}
{selection ==="private-attendance" && <DoctorsAttendance />} {/* ✅ NEW */}



        {/* ✅ Toast + Footer */}
        <ToastContainer />
        <div className="text-center mt-5 text-secondary small">
          © {new Date().getFullYear()} Rawalpindi Institute of Cardiology — All rights reserved.
        </div>
      </div>
    </div>
  );
};
export default DutyForm;
